(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-statement"] && !Shopify.designMode) return;
  try {
    
  class AboutStatementRotator extends HTMLElement {
    connectedCallback() {
      this.phrases = Array.from(this.querySelectorAll('.about-statement__phrase'));
      if (this.phrases.length <= 1) return;

      this.classList.add('is-rotating');
      this.index = 0;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reducedMotion) this.start();
    }

    start() {
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.go((this.index + 1) % this.phrases.length);
      }, 4000);
    }

    go(index) {
      const outgoing = this.phrases[this.index];
      outgoing.classList.remove('is-active');
      outgoing.classList.add('is-leaving');

      this.index = index;
      this.phrases[this.index].classList.add('is-active');

      // Once the slide finishes, drop "is-leaving" — that also removes the
      // transition rule, so it snaps back below the fold instantly instead
      // of animating back into view, ready for its next turn.
      clearTimeout(this.resetTimer);
      this.resetTimer = setTimeout(() => {
        outgoing.classList.remove('is-leaving');
      }, 2400);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      clearTimeout(this.resetTimer);
    }
  }

  customElements.define('about-statement-rotator', AboutStatementRotator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.announcement-bar__track');
      if (!this.track) return;

      this.originalItems = Array.from(this.track.children);
      this.originalCount = this.originalItems.length;
      if (!this.originalCount) return;

      this.offset = 0;
      this.loopDistance = 0;
      this.speed = 0;
      this.lastTime = null;
      this.paused = false;

      this.fillTrack();
      this.measure();

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.fillTrack();
          this.measure();
        });
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.track);
      }

      this.addEventListener('mouseenter', () => { this.paused = true; });
      this.addEventListener('mouseleave', () => { this.paused = false; });

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reducedMotion) {
        this.boundTick = this.tick.bind(this);
        requestAnimationFrame(this.boundTick);
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    fillTrack() {
      const containerWidth = this.getBoundingClientRect().width;
      if (!containerWidth) return;

      let guard = 0;
      while (
        (this.track.children.length < this.originalCount * 2 || this.track.scrollWidth < containerWidth * 2)
        && guard < 20
      ) {
        this.originalItems.forEach((item) => {
          const clone = item.cloneNode(true);
          this.stripEditorAttributes(clone);
          clone.setAttribute('aria-hidden', 'true');
          this.track.appendChild(clone);
        });
        guard++;
      }
    }

    stripEditorAttributes(el) {
      if (el.attributes) {
        Array.from(el.attributes).forEach((attr) => {
          if (attr.name === 'id' || attr.name.indexOf('data-') === 0) {
            el.removeAttribute(attr.name);
          }
        });
      }
      Array.from(el.children || []).forEach((child) => this.stripEditorAttributes(child));
    }

    measure() {
      const items = Array.from(this.track.children);
      const firstItem = items[0];
      const firstClone = items[this.originalCount];
      if (!firstItem || !firstClone) return;

      const distance = firstClone.getBoundingClientRect().left - firstItem.getBoundingClientRect().left;
      if (distance > 0 && distance !== this.loopDistance) {
        this.loopDistance = distance;
        this.speed = this.loopDistance / 12000;
        this.offset = (((this.offset % this.loopDistance) + this.loopDistance) % this.loopDistance) - this.loopDistance;
        this.track.style.transform = `translateX(${this.offset}px)`;
      }
    }

    tick(time) {
      if (!this.isConnected) return;
      if (this.lastTime === null) this.lastTime = time;
      const delta = time - this.lastTime;
      this.lastTime = time;

      if (!this.paused && this.loopDistance > 0) {
        this.offset -= this.speed * delta;
        if (this.offset <= -this.loopDistance) this.offset += this.loopDistance;
        this.track.style.transform = `translateX(${this.offset}px)`;
      }

      requestAnimationFrame(this.boundTick);
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"] && !Shopify.designMode) return;
  try {
    
  class ArticleShare extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-copy-link]');
        if (button) this.copyLink(button);
      });
    }

    async copyLink(button) {
      try {
        await navigator.clipboard.writeText(button.dataset.url);
      } catch (error) {
        console.error('article-share', error);
        return;
      }

      const label = button.querySelector('[data-copy-label]');
      if (!label || button.disabled) return;

      const original = label.textContent;
      label.textContent = 'Link copiado!';
      button.disabled = true;
      setTimeout(() => {
        label.textContent = original;
        button.disabled = false;
      }, 2000);
    }
  }

  customElements.define('article-share', ArticleShare);

  class ArticleProducts extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('.article__products-tab');
        if (tab) {
          this.activateProduct(tab.dataset.target);
          return;
        }

        const chevron = event.target.closest('.product-card__variant-chevron');
        if (chevron) {
          this.stepVariant(chevron.closest('.product-card'), chevron.dataset.direction);
        }
      });

      this.buildTabs();

      this.grid = this.querySelector('.article__products-grid');
      if (this.grid && this.grid.children.length > 1) {
        this.gridQuery = window.matchMedia('(min-width: 750px)');
        new ResizeObserver(() => this.updateGridLayout()).observe(this.grid);
      }
    }

    buildTabs() {
      const tabsContainer = this.querySelector('[data-tabs]');
      const cards = Array.from(this.querySelectorAll('.product-card'));

      if (!tabsContainer || cards.length < 2) return;

      cards.forEach((card, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'article__products-tab' + (index === 0 ? ' is-active' : '');
        button.setAttribute('role', 'tab');
        button.dataset.target = card.id;
        button.textContent = card.dataset.tabLabel || '';
        tabsContainer.appendChild(button);
      });
    }

    naturalCardWidth(card) {
      const clone = card.cloneNode(true);
      clone.removeAttribute('id');
      clone.style.position = 'absolute';
      clone.style.visibility = 'hidden';
      clone.style.width = 'auto';
      clone.style.maxWidth = 'none';
      document.body.appendChild(clone);
      const width = clone.getBoundingClientRect().width;
      document.body.removeChild(clone);
      return width;
    }

    updateGridLayout() {
      if (!this.gridQuery.matches) {
        this.grid.classList.remove('article__products-grid--stacked');
        return;
      }

      const cards = Array.from(this.grid.querySelectorAll('.product-card'));
      const gap = parseFloat(getComputedStyle(this.grid).columnGap) || 0;
      const neededWidth = cards.reduce((sum, card) => sum + this.naturalCardWidth(card), 0) + gap * (cards.length - 1);

      this.grid.classList.toggle('article__products-grid--stacked', neededWidth > this.grid.clientWidth);
    }

    activateProduct(targetId) {
      this.querySelectorAll('.article__products-tab').forEach((tab) => {
        tab.classList.toggle('is-active', tab.dataset.target === targetId);
      });
      this.querySelectorAll('.product-card').forEach((card) => {
        card.classList.toggle('is-active', card.id === targetId);
      });
    }

    stepVariant(card, direction) {
      if (!card) return;

      const rows = Array.from(card.querySelectorAll('.product-card__variant-mobile'));
      if (!rows.length) return;

      const currentIndex = rows.findIndex((row) => row.classList.contains('is-active'));
      const delta = direction === 'next' ? 1 : -1;
      const nextIndex = (currentIndex + delta + rows.length) % rows.length;

      rows.forEach((row, index) => row.classList.toggle('is-active', index === nextIndex));
    }
  }

  customElements.define('article-products', ArticleProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits-ticker"] && !Shopify.designMode) return;
  try {
    
  class BenefitsTickerMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.benefits-ticker__track');
      if (!this.track) return;

      this.originalItems = Array.from(this.track.children);
      this.originalCount = this.originalItems.length;
      if (!this.originalCount) return;

      this.offset = 0;
      this.loopDistance = 0;
      this.speed = 0;
      this.lastTime = null;
      this.paused = false;

      this.fillTrack();
      this.measure();

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.fillTrack();
          this.measure();
        });
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.track);
      }

      this.addEventListener('mouseenter', () => { this.paused = true; });
      this.addEventListener('mouseleave', () => { this.paused = false; });

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reducedMotion) {
        this.boundTick = this.tick.bind(this);
        requestAnimationFrame(this.boundTick);
      }
    }

    fillTrack() {
      const containerWidth = this.getBoundingClientRect().width;
      if (!containerWidth) return;

      let guard = 0;
      while (
        (this.track.children.length < this.originalCount * 2 || this.track.scrollWidth < containerWidth * 2)
        && guard < 20
      ) {
        this.originalItems.forEach((item) => {
          const clone = item.cloneNode(true);
          this.stripEditorAttributes(clone);
          clone.setAttribute('aria-hidden', 'true');
          this.track.appendChild(clone);
        });
        guard++;
      }
    }

    stripEditorAttributes(el) {
      if (el.attributes) {
        Array.from(el.attributes).forEach((attr) => {
          if (attr.name === 'id' || attr.name.indexOf('data-') === 0) {
            el.removeAttribute(attr.name);
          }
        });
      }
      Array.from(el.children || []).forEach((child) => this.stripEditorAttributes(child));
    }

    measure() {
      const items = Array.from(this.track.children).map((wrapper) => wrapper.firstElementChild || wrapper);
      const firstItem = items[0];
      const firstClone = items[this.originalCount];
      if (!firstItem || !firstClone) return;

      const distance = firstClone.getBoundingClientRect().left - firstItem.getBoundingClientRect().left;
      if (distance > 0 && distance !== this.loopDistance) {
        this.loopDistance = distance;
        this.speed = this.loopDistance / 20000;
        this.offset = (((this.offset % this.loopDistance) + this.loopDistance) % this.loopDistance) - this.loopDistance;
        this.track.style.transform = `translateX(${this.offset}px)`;
      }
    }

    tick(time) {
      if (this.lastTime === null) this.lastTime = time;
      const delta = time - this.lastTime;
      this.lastTime = time;

      if (!this.paused && this.loopDistance > 0) {
        this.offset -= this.speed * delta;
        if (this.offset <= -this.loopDistance) this.offset += this.loopDistance;
        this.track.style.transform = `translateX(${this.offset}px)`;
      }

      requestAnimationFrame(this.boundTick);
    }
  }

  customElements.define('benefits-ticker-marquee', BenefitsTickerMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawerApp extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-cart-dialog]');
      this.shippingCents = null;

      // Read the actual rendered section id rather than hardcoding it, since
      // sections placed via a group JSON (footer-group.json) may not use
      // their instance key as-is for the shopify-section- wrapper id.
      const wrapper = this.closest('[id^="shopify-section-"]');
      this.sectionId = wrapper ? wrapper.id.replace('shopify-section-', '') : 'cart-drawer';

      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-toggle]')) {
          event.preventDefault();
          this.open();
          return;
        }

        // Any link with data-buy-again="<variant id>" (account / order
        // history): add 1 unit and open the drawer, staying on the page. On
        // failure (sold out, removed…) the link's own href is followed.
        const buyAgain = event.target.closest('[data-buy-again]');
        if (buyAgain) {
          event.preventDefault();
          this.addAndOpen(buyAgain.dataset.buyAgain, buyAgain.href);
        }
      });

      this.addEventListener('input', (event) => {
        if (event.target.matches('[data-cart-cep]')) {
          let value = event.target.value.replace(/\D/g, '');
          value = value.replace(/^(\d{5})(\d)/, '$1-$2');
          event.target.value = value;
          this.syncShippingButton();
        }
      });

      // "Calcule o frete" only works with a full CEP; after a calculation it
      // stays disabled until the shopper goes back to the CEP field.
      this.addEventListener('focusin', (event) => {
        if (!event.target.matches('[data-cart-cep]')) return;
        this.shippingLocked = false;
        this.syncShippingButton();
      });

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-close]')) {
          this.close();
          return;
        }
        if (event.target === this.dialog) {
          this.close();
          return;
        }

        const decrease = event.target.closest('[data-qty-decrease]');
        const increase = event.target.closest('[data-qty-increase]');
        if (decrease || increase) {
          const wrapper = (decrease || increase).closest('[data-cart-qty]');
          const valueEl = wrapper.querySelector('[data-qty-value]');
          const current = parseInt(valueEl.textContent, 10) || 0;
          const next = increase ? current + 1 : Math.max(0, current - 1);
          this.queueLineChange(wrapper, next);
          return;
        }

        const remove = event.target.closest('[data-cart-remove]');
        if (remove) {
          if (remove.disabled) return;
          remove.disabled = true;
          remove.closest('.cart-drawer__item')?.classList.add('is-updating');
          this.queueLineChange(null, 0, remove.dataset.line, true);
          return;
        }

        if (event.target.closest('[data-cart-shipping-submit]')) {
          this.submitShipping();
          return;
        }

        const shippingOption = event.target.closest('.cart-drawer__shipping-options .shipping-calculator__result');
        if (shippingOption) {
          this.selectShipping(shippingOption);
          return;
        }

        if (event.target.closest('[data-cart-checkout]')) {
          event.preventDefault();
          this.goToCheckout();
        }
      });

      this.addEventListener('keydown', (event) => {
        const shippingOption = event.target.closest('.cart-drawer__shipping-options .shipping-calculator__result');
        if (shippingOption && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          this.selectShipping(shippingOption);
        }
      });

      this.addEventListener('change', (event) => {
        const select = event.target.closest('[data-frequency-select]');
        if (select) {
          this.changeSellingPlan(select.dataset.line, select.value);
        }
      });

      this.addEventListener('shipping-calculator:change', (event) => {
        this.handleShippingResult(event.detail);
      });

      this.dialog?.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });

      this.dialog?.addEventListener('transitionend', (event) => {
        if (event.propertyName === 'transform' && !this.dialog.classList.contains('is-open')) {
          this.dialog.close();
        }
      });

      // Back from Yampi's checkout via the browser's back button, the page
      // may come from the bfcache with the checkout still "in progress".
      window.addEventListener('pageshow', (event) => {
        if (!event.persisted) return;
        this.checkingOut = false;
        if (typeof window.hideYampiLoader === 'function') window.hideYampiLoader();
      });

      // CEP calculated in another field (e.g. the PDP): keep this one in sync.
      window.addEventListener('novvo:cep-change', (event) => {
        const input = this.querySelector('[data-cart-cep]');
        const calculator = this.querySelector('.cart-drawer__shipping-options');
        if (!input || event.detail.source === calculator || document.activeElement === input) return;
        if (input.value === event.detail.cep) return;
        input.value = event.detail.cep;
        this.shippingLocked = false;
        this.syncShippingButton();
      });

      this.openFromRedirect();
    }

    openFromRedirect() {
      const params = new URLSearchParams(window.location.search);
      if (params.get('open_cart') !== '1') {
        return;
      }

      params.delete('open_cart');
      const query = params.toString();
      const newUrl = window.location.pathname + (query ? `?${query}` : '') + window.location.hash;
      window.history.replaceState({}, '', newUrl);
      this.open();

      // Landing here means the /cart redirect worked, so reset its loop
      // counter (see sections/cart.liquid) for the next time it's used.
      try {
        sessionStorage.removeItem('novvo:cartRedirectCount');
      } catch (e) {}
    }

    open() {
      if (!this.dialog) {
        return;
      }
      this.dialog.showModal();
      requestAnimationFrame(() => this.dialog.classList.add('is-open'));
      this.refresh();
      this.trackViewCart();
    }

    close() {
      this.dialog?.classList.remove('is-open');
    }

    async addAndOpen(variantId, fallbackUrl) {
      if (this.adding) return;
      this.adding = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
        });
        if (!response.ok) throw new Error('add failed');
        const added = await response.json();
        const line = added && Array.isArray(added.items) ? added.items[0] : null;

        // P1 — add_to_cart
        // Quando: 'Comprar novamente' (conta / histórico) adicionou ao carrinho.
        if (line && window.NovvoTracking) {
          window.NovvoTracking.pushEcommerce('add_to_cart', {
            currency: window.NovvoTracking.currency,
            value: line.final_price / 100,
            items: [window.NovvoTracking.cartItem(line, 1)],
          });
        }

        const cart = await fetch('/cart.js', { cache: 'no-store' }).then((r) => r.json());
        this.updateCartCount(cart.item_count);
        this.open();
      } catch (e) {
        if (fallbackUrl) window.location.href = fallbackUrl;
      } finally {
        this.adding = false;
      }
    }

    // +/− update the number on screen right away and are batched: one
    // /cart/change.js per line once the clicks stop (400ms), then a single
    // refresh (which also recalculates shipping). Removing is sent at once.
    queueLineChange(wrapper, quantity, line = wrapper && wrapper.dataset.line, immediate = false) {
      this.qtyQueue = this.qtyQueue || {};
      this.qtyQueue[line] = quantity;

      if (wrapper) {
        const valueEl = wrapper.querySelector('[data-qty-value]');
        if (valueEl) valueEl.textContent = String(quantity).padStart(2, '0');
        wrapper.closest('.cart-drawer__item')?.classList.add('is-updating');
      }

      clearTimeout(this.qtyTimer);
      if (immediate) {
        this.flushLineChanges();
      } else {
        this.qtyTimer = setTimeout(() => this.flushLineChanges(), 400);
      }
    }

    async flushLineChanges() {
      clearTimeout(this.qtyTimer);
      if (this.flushing) {
        // Clicked again while saving: run once more when this one ends.
        this.flushAgain = true;
        return this.flushing;
      }
      const entries = Object.entries(this.qtyQueue || {});
      this.qtyQueue = {};
      if (!entries.length) return;

      this.flushing = (async () => {
        // Highest line first, so a removed line doesn't shift the others.
        entries.sort((a, b) => Number(b[0]) - Number(a[0]));
        for (const [line, quantity] of entries) {
          await this.changeLine(line, quantity, false);
        }
        await this.refresh();
      })();

      try {
        await this.flushing;
      } finally {
        this.flushing = null;
        if (this.flushAgain) {
          this.flushAgain = false;
          await this.flushLineChanges();
        }
      }
    }

    async changeLine(line, quantity, refresh = true) {
      const previousLine = await this.getTrackedLine(line);
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
      });
      const cart = await response.json();
      if (response.ok) this.trackLineChange(previousLine, cart);
      this.updateCartCount(cart.item_count);
      if (refresh) await this.refresh();
    }

    async changeSellingPlan(line, sellingPlan) {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(line), selling_plan: sellingPlan }),
      });
      const cart = await response.json();
      if (response.ok) this.trackedCart = cart;
      this.updateCartCount(cart.item_count);
      await this.refresh();
    }

    // Checkout is hosted by Yampi. Mirrors what YampiSnippet does on the cart
    // page with skip_cart (snippets/YampiSnippet.liquid, left untouched):
    // send /cart.json to Yampi's API, empty the Shopify cart (the order comes
    // back to Shopify after payment; bundles are kept, as Yampi does) and
    // redirect to Yampi's checkout carrying the UTMs. Reuses the snippet's
    // own globals (cartEndpoint, ymp_getUrlWithUtms, show/hideYampiLoader).
    // Falls back to Shopify's /checkout if Yampi isn't available or answers
    // without a checkout URL.
    async goToCheckout() {
      if (this.checkingOut) return;
      this.checkingOut = true;

      // Quantity clicks still waiting to be saved go first.
      await this.flushLineChanges();

      let cart;
      try {
        cart = await fetch('/cart.json', { cache: 'no-store' }).then((r) => r.json());
      } catch (e) {
        window.location.href = '/checkout';
        return;
      }

      this.trackBeginCheckout(cart);

      const yampi = await this.requestYampiCheckout(cart);
      if (!yampi) {
        if (typeof window.hideYampiLoader === 'function') window.hideYampiLoader();
        window.location.href = '/checkout';
        return;
      }

      const hasBundles = cart.items.some((item) => item.has_components);
      if (yampi.skip_cart && !hasBundles) {
        await fetch('/cart/clear.js', { method: 'POST' }).catch(() => {});
      }

      window.location.href =
        typeof window.ymp_getUrlWithUtms === 'function'
          ? window.ymp_getUrlWithUtms(yampi.checkout_direct_url)
          : yampi.checkout_direct_url;
    }

    // Yampi's answer ({ active, skip_cart, checkout_direct_url }), or null.
    async requestYampiCheckout(cart) {
      if (typeof window.cartEndpoint !== 'string') return null;

      // Yampi's loader is a fixed overlay, but the open <dialog> sits in the
      // top layer above it — close the drawer so the loader shows.
      this.close();
      if (typeof window.showYampiLoader === 'function') window.showYampiLoader();

      try {
        const response = await fetch(window.cartEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            shop: window.location.host,
            shopify_internal_domain: window.shopifyInternalUrl,
            cart_payload: cart,
          }),
        });
        const data = await response.json();
        return data && data.active && data.checkout_direct_url ? data : null;
      } catch (e) {
        return null;
      }
    }

    // P1 — begin_checkout
    // Quando: clique em 'Finalizar pedido' no drawer, com os itens do carrinho
    // (mesmo formato do view_cart). Exceção à regra de não enviar
    // begin_checkout: o Custom Pixel da Shopify não enxerga o checkout da Yampi.
    trackBeginCheckout(cart) {
      if (!window.NovvoTracking || !cart.items.length) return;

      window.NovvoTracking.pushEcommerce('begin_checkout', {
        currency: window.NovvoTracking.currency,
        value: cart.total_price / 100,
        items: cart.items.map((item) => window.NovvoTracking.cartItem(item, item.quantity)),
      });
    }

    // P2 — view_cart
    // Quando: abrir o carrinho (após o GET /cart.js do drawer — the drawer
    // renders via the Section Rendering API, so items come from /cart.js).
    async trackViewCart() {
      if (!window.NovvoTracking) {
        return;
      }
      try {
        const cart = await fetch('/cart.js', { cache: 'no-store' }).then((r) => r.json());
        this.trackedCart = cart;
        if (!cart.items.length) {
          return;
        }

        window.NovvoTracking.pushEcommerce('view_cart', {
          currency: window.NovvoTracking.currency,
          value: cart.total_price / 100,
          items: cart.items.map((item) => window.NovvoTracking.cartItem(item, item.quantity)),
        });
      } catch (e) {}
    }

    // The /cart.js line as it was right before a change (line is 1-based).
    async getTrackedLine(line) {
      if (!window.NovvoTracking) return null;
      try {
        if (!this.trackedCart) {
          this.trackedCart = await fetch('/cart.js', { cache: 'no-store' }).then((r) => r.json());
        }
        return this.trackedCart.items[Number(line) - 1] || null;
      } catch (e) {
        return null;
      }
    }

    // P2 — remove_from_cart
    // Quando: remover item ou diminuir quantidade no drawer.
    // P1 — add_to_cart
    // Quando: aumentar quantidade ("+") no drawer.
    // Só o item alterado, com a quantidade que entrou/saiu.
    trackLineChange(previousLine, cart) {
      this.trackedCart = cart;
      if (!previousLine || !window.NovvoTracking) {
        return;
      }

      const current = cart.items.find((item) => item.key === previousLine.key);
      const delta = (current ? current.quantity : 0) - previousLine.quantity;
      if (delta === 0) {
        return;
      }

      const quantity = Math.abs(delta);
      window.NovvoTracking.pushEcommerce(delta > 0 ? 'add_to_cart' : 'remove_from_cart', {
        currency: window.NovvoTracking.currency,
        value: (previousLine.final_price * quantity) / 100,
        items: [window.NovvoTracking.cartItem(previousLine, quantity)],
      });
    }

    async refresh() {
      const response = await fetch(`${window.location.pathname}?section_id=${this.sectionId}`, {
        cache: 'no-store',
      });
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');

      const newContent = parsed.querySelector('[data-cart-content]');
      const currentContent = this.querySelector('[data-cart-content]');
      if (newContent && currentContent) {
        currentContent.replaceWith(newContent);
      }

      const newCount = parsed.querySelector('.cart-drawer__count');
      const currentCount = this.querySelector('.cart-drawer__count');
      if (newCount && currentCount) {
        currentCount.replaceWith(newCount);
      }

      this.shippingCents = null;
      // The footer (CEP field + button) was re-rendered: bring the CEP and
      // the last shipping result back.
      this.shippingCalculating = false;
      this.shippingLocked = false;
      this.syncShippingButton();
      this.restoreShipping();
    }

    updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }

    submitShipping() {
      const input = this.querySelector('[data-cart-cep]');
      const button = this.querySelector('[data-cart-shipping-submit]');
      if (!input || (button && button.disabled)) return;
      this.pendingShippingCents = null;
      this.runShipping(input.value);
    }

    runShipping(cep) {
      const button = this.querySelector('[data-cart-shipping-submit]');
      const calculator = this.querySelector('.cart-drawer__shipping-options');
      if (!calculator || typeof calculator.calculateFor !== 'function') return;

      this.shippingCalculating = true;
      if (button) {
        button.dataset.label = button.dataset.label || button.textContent;
        button.textContent = 'Calculando...';
        button.disabled = true;
      }
      const valueEl = this.querySelector('[data-cart-shipping-value]');
      if (valueEl) valueEl.textContent = 'Calculando...';
      calculator.calculateFor(cep);
    }

    // Shipping state survives closing/reopening the drawer and page changes:
    // the CEP comes from the shared storage (window.NovvoCep, see
    // assets/shipping-calculator.js) and the last result is kept in
    // sessionStorage for this exact cart. If the cart changed since, it's
    // recalculated for the same CEP.
    cartShippingKey() {
      const content = this.querySelector('[data-cart-content]');
      const quantities = Array.from(this.querySelectorAll('[data-qty-value]')).map((el) => el.textContent.trim());
      return (content ? content.dataset.cartSubtotalCents : '') + '|' + quantities.join(',');
    }

    readShippingCache() {
      try {
        return JSON.parse(sessionStorage.getItem('novvo:cartShipping') || 'null');
      } catch (e) {
        return null;
      }
    }

    writeShippingCache(data) {
      try {
        if (data) {
          sessionStorage.setItem('novvo:cartShipping', JSON.stringify(data));
        } else {
          sessionStorage.removeItem('novvo:cartShipping');
        }
      } catch (e) {}
    }

    restoreShipping() {
      const input = this.querySelector('[data-cart-cep]');
      const calculator = this.querySelector('.cart-drawer__shipping-options');
      if (!input || !calculator) return;

      const saved = window.NovvoCep ? window.NovvoCep.get() : '';
      if (!input.value && saved) input.value = saved;
      const cep = input.value.replace(/\D/g, '');
      if (cep.length !== 8) {
        this.syncShippingButton();
        return;
      }

      const cache = this.readShippingCache();
      if (cache && cache.cep === cep && cache.cart === this.cartShippingKey() && Array.isArray(cache.rates) && typeof calculator.renderResults === 'function') {
        // Same CEP, same cart: show the saved options right away.
        this.pendingShippingCents = cache.selectedCents;
        calculator.renderResults(cache.rates);
      } else {
        this.pendingShippingCents = cache && cache.cep === cep ? cache.selectedCents : null;
        this.runShipping(cep);
      }
    }

    syncShippingButton() {
      const input = this.querySelector('[data-cart-cep]');
      const button = this.querySelector('[data-cart-shipping-submit]');
      if (!input || !button) return;

      if (!this.shippingCalculating && button.dataset.label) {
        button.textContent = button.dataset.label;
      }
      const hasCep = input.value.replace(/\D/g, '').length === 8;
      button.disabled = this.shippingCalculating || this.shippingLocked || !hasCep;
    }

    handleShippingResult(detail) {
      const valueEl = this.querySelector('[data-cart-shipping-value]');
      if (!valueEl) {
        return;
      }

      // Calculation finished: lock the button until the CEP field is used again.
      this.shippingCalculating = false;
      this.shippingLocked = true;
      this.syncShippingButton();

      const cep = (this.querySelector('[data-cart-cep]')?.value || '').replace(/\D/g, '');

      if (detail.error || !detail.rates.length) {
        valueEl.textContent = detail.error || 'Nenhuma opção de frete encontrada';
        this.shippingCents = null;
        this.writeShippingCache(null);
      } else {
        this.writeShippingCache({ cep, cart: this.cartShippingKey(), rates: detail.rates, selectedCents: null });

        // The cheapest option starts selected (or the one picked before, when
        // restoring); the shopper can pick another.
        const options = this.setupShippingOptions(detail.rates);
        const previous = this.pendingShippingCents != null
          ? options.find((option) => Number(option.dataset.cents) === Number(this.pendingShippingCents))
          : null;
        this.pendingShippingCents = null;
        const cheapest = options.reduce(
          (min, option) => (Number(option.dataset.cents) < Number(min.dataset.cents) ? option : min),
          options[0]
        );
        const initial = previous || cheapest;
        if (initial) {
          this.selectShipping(initial);
          return;
        }
        this.shippingCents = null;
      }

      this.updateTotal();
    }

    // Turns the option rows rendered by assets/shipping-calculator.js (same
    // order as `rates`) into a radio group.
    setupShippingOptions(rates) {
      const list = this.querySelector('.cart-drawer__shipping-options [data-shipping-results]');
      if (!list) return [];
      list.setAttribute('role', 'radiogroup');
      list.setAttribute('aria-label', 'Opções de frete');

      const options = Array.from(list.querySelectorAll('.shipping-calculator__result'));
      options.forEach((option, i) => {
        const rate = rates[i];
        option.dataset.cents = rate ? Math.round(parseFloat(rate.price) * 100) : 0;
        option.setAttribute('role', 'radio');
        option.setAttribute('aria-checked', 'false');
        option.tabIndex = 0;
      });
      return options;
    }

    selectShipping(option) {
      const options = option.parentElement.querySelectorAll('.shipping-calculator__result');
      options.forEach((el) => {
        const selected = el === option;
        el.classList.toggle('is-selected', selected);
        el.setAttribute('aria-checked', selected ? 'true' : 'false');
      });

      this.shippingCents = Number(option.dataset.cents) || 0;
      const cache = this.readShippingCache();
      if (cache) this.writeShippingCache({ ...cache, selectedCents: this.shippingCents });
      const valueEl = this.querySelector('[data-cart-shipping-value]');
      if (valueEl) valueEl.textContent = this.shippingCents === 0 ? 'Grátis' : this.formatMoney(this.shippingCents);
      this.updateTotal();
    }

    updateTotal() {
      const totalEl = this.querySelector('[data-cart-total-value]');
      const contentEl = this.querySelector('[data-cart-content]');
      if (!totalEl || !contentEl) {
        return;
      }

      const subtotal = parseInt(contentEl.dataset.cartSubtotalCents || '0', 10);
      totalEl.textContent = this.formatMoney(subtotal + (this.shippingCents || 0));
    }

    formatMoney(cents) {
      return `R$ ${(cents / 100).toFixed(2).replace('.', ',')}`;
    }
  }

  customElements.define('cart-drawer-app', CartDrawerApp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-account"]) return;
  try {
    
  class AccountDashboard extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const deleteButton = event.target.closest('[data-confirm-delete]');
        if (deleteButton) {
          const message = deleteButton.dataset.confirmDelete;
          if (message && !window.confirm(message)) {
            event.preventDefault();
          }
        }
      });
    }
  }

  customElements.define('account-dashboard', AccountDashboard);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-address-form"]) return;
  try {
    
  class CustomerAddressFormApp extends HTMLElement {
    connectedCallback() {
      this.showView(this.dataset.initialView || 'add');

      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-select-trigger]');
        if (trigger) {
          const group = trigger.closest('[data-custom-select]');
          const wasOpen = group.classList.contains('is-open');
          this.closeAllSelects();
          if (!wasOpen) this.openSelect(group);
          return;
        }

        const option = event.target.closest('.customer-address-form__select-option');
        if (option) {
          this.selectOption(option.closest('[data-custom-select]'), option);
          return;
        }

        if (!event.target.closest('[data-custom-select]')) {
          this.closeAllSelects();
        }

        const showAdd = event.target.closest('[data-show-add-form]');
        if (showAdd) {
          this.showView('add');
          return;
        }

        const showEdit = event.target.closest('[data-show-edit-form]');
        if (showEdit) {
          this.showView('edit-' + showEdit.dataset.showEditForm);
          return;
        }

        const backToList = event.target.closest('[data-back-to-list]');
        if (backToList) {
          this.showView('list');
          return;
        }

        const deleteButton = event.target.closest('[data-confirm-delete]');
        if (deleteButton) {
          const message = deleteButton.dataset.confirmDelete;
          if (message && !window.confirm(message)) {
            event.preventDefault();
          }
        }
      });

      this.addEventListener('keydown', (event) => {
        const group = event.target.closest('[data-custom-select]');
        if (!group) return;

        const trigger = group.querySelector('[data-select-trigger]');

        if (event.target === trigger) {
          if (event.key === 'Escape' && group.classList.contains('is-open')) {
            event.preventDefault();
            this.closeSelect(group);
          } else if (['Enter', ' ', 'ArrowDown', 'ArrowUp'].includes(event.key)) {
            event.preventDefault();
            this.openSelect(group);
            const options = group.querySelectorAll('.customer-address-form__select-option');
            const active = group.querySelector('.customer-address-form__select-option.is-selected') || options[0];
            if (active) active.focus();
          }
          return;
        }

        if (event.target.matches('.customer-address-form__select-option')) {
          const options = Array.from(group.querySelectorAll('.customer-address-form__select-option'));
          const index = options.indexOf(event.target);

          if (event.key === 'ArrowDown') {
            event.preventDefault();
            (options[index + 1] || options[0]).focus();
          } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            (options[index - 1] || options[options.length - 1]).focus();
          } else if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.selectOption(group, event.target);
            trigger.focus();
          } else if (event.key === 'Escape') {
            event.preventDefault();
            this.closeSelect(group);
            trigger.focus();
          }
        }
      });

      this.addEventListener('focusout', (event) => {
        const group = event.target.closest('[data-custom-select]');
        if (!group) return;
        requestAnimationFrame(() => {
          if (!group.contains(document.activeElement)) {
            this.closeSelect(group);
          }
        });
      });

      this.addEventListener('submit', (event) => {
        const form = event.target.closest('form');
        if (!form) return;

        let hasInvalidSelect = false;
        form.querySelectorAll('[data-custom-select]').forEach((group) => {
          const select = group.querySelector('[data-select-native]');
          if (select.required && !select.value) {
            group.classList.add('is-invalid');
            if (!hasInvalidSelect) {
              this.closeAllSelects();
              this.openSelect(group);
              group.querySelector('[data-select-trigger]').focus();
            }
            hasInvalidSelect = true;
          }
        });
        if (hasInvalidSelect) {
          event.preventDefault();
          return;
        }

        const fullNameInput = form.querySelector('[data-full-name]');
        const firstNameInput = form.querySelector('[data-first-name]');
        const lastNameInput = form.querySelector('[data-last-name]');
        if (fullNameInput && firstNameInput && lastNameInput) {
          const parts = fullNameInput.value.trim().split(/\s+/);
          firstNameInput.value = parts.shift() || '';
          lastNameInput.value = parts.join(' ');
        }

        if (form.hasAttribute('data-preview-form')) {
          event.preventDefault();
          return;
        }

        if (form.hasAttribute('data-address-form')) {
          event.preventDefault();
          this.submitAddressForm(form);
        }
      });

      this.addEventListener('input', (event) => {
        if (event.target.matches('[data-zip]')) {
          let value = event.target.value.replace(/\D/g, '');
          value = value.replace(/^(\d{5})(\d)/, '$1-$2');
          event.target.value = value;
        }
      });
    }

    showView(view) {
      this.closeAllSelects();
      this.querySelectorAll('[data-view]').forEach((el) => {
        el.hidden = el.dataset.view !== view;
      });
    }

    async submitAddressForm(form) {
      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton) submitButton.disabled = true;

      try {
        await fetch(form.action, {
          method: form.method || 'POST',
          body: new FormData(form),
        });
      } catch (error) {
        // Ignore network errors here — reloading below shows the current
        // state either way, and Shopify's own redirect_to isn't honored
        // by the customer_address form, so a full page nav is unreliable.
      }

      window.location.reload();
    }

    openSelect(group) {
      group.classList.add('is-open');
      group.querySelector('[data-select-trigger]').setAttribute('aria-expanded', 'true');
      group.querySelector('[data-select-list]').hidden = false;
    }

    closeSelect(group) {
      group.classList.remove('is-open');
      group.querySelector('[data-select-trigger]').setAttribute('aria-expanded', 'false');
      group.querySelector('[data-select-list]').hidden = true;
    }

    closeAllSelects() {
      this.querySelectorAll('[data-custom-select].is-open').forEach((group) => this.closeSelect(group));
    }

    selectOption(group, option) {
      const select = group.querySelector('[data-select-native]');
      const label = group.querySelector('[data-select-label]');
      const trigger = group.querySelector('[data-select-trigger]');

      select.value = option.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));

      label.textContent = option.textContent.trim();
      trigger.classList.remove('customer-address-form__select-trigger--placeholder');
      group.classList.remove('is-invalid');

      group.querySelectorAll('.customer-address-form__select-option').forEach((el) => {
        el.classList.toggle('is-selected', el === option);
      });

      this.closeSelect(group);
    }
  }

  customElements.define('customer-address-form-app', CustomerAddressFormApp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-login"]) return;
  try {
    
  class CustomerLoginApp extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-recover-open]')) {
          event.preventDefault();
          this.classList.add('is-recovering');
        }

        if (event.target.closest('[data-recover-close]')) {
          event.preventDefault();
          this.classList.remove('is-recovering');
        }

        const toggle = event.target.closest('[data-password-toggle]');
        if (toggle) {
          const input = toggle.parentElement.querySelector('[data-password-input]');
          if (input) {
            const isVisible = input.type === 'password';
            input.type = isVisible ? 'text' : 'password';
            toggle.querySelector('[data-icon-show]').toggleAttribute('hidden', isVisible);
            toggle.querySelector('[data-icon-hide]').toggleAttribute('hidden', !isVisible);
          }
        }

        const socialButton = event.target.closest('[data-social-provider]');
        if (socialButton) {
          this.goToSocialLogin(socialButton.dataset.socialProvider);
        }
      });

      this.addEventListener('input', (event) => {
        if (event.target.id === 'CustomerEmail' || event.target.id === 'CustomerPassword') {
          this.updateLoginSubmitState();
        }
      });

      this.updateLoginSubmitState();
    }

    updateLoginSubmitState() {
      const submitButton = this.querySelector('[data-login-submit]');
      if (!submitButton) return;

      const emailInput = this.querySelector('#CustomerEmail');
      const passwordInput = this.querySelector('#CustomerPassword');

      const hasEmail = !!emailInput?.value.trim();
      // If there's no password field (passwordless login), only email is required.
      const hasPassword = passwordInput ? !!passwordInput.value.trim() : true;

      submitButton.disabled = !(hasEmail && hasPassword);
    }

    goToSocialLogin(provider) {
      const config = this.querySelector('[data-social-login]');
      if (!config) return;

      const returnUrl = new URLSearchParams(window.location.search).get('return_url') || '/account';

      const params = new URLSearchParams({
        shop: config.dataset.shop,
        locale: config.dataset.locale,
        locale_path: config.dataset.localePath,
        host: config.dataset.host,
        return_url: returnUrl,
      });

      // P2 — login (method: 'google' | 'apple')
      // Quando: login com SUCESSO — só é enviado no próximo carregamento se
      // o visitante voltar logado (see snippets/tracking-datalayer.liquid).
      window.NovvoTracking?.setPending({ event: 'login', method: provider }, 'logged_in');

      window.location.href = `https://app.froonze.com/social_logins/login/${provider}?${params.toString()}`;
    }
  }

  customElements.define('customer-login-app', CustomerLoginApp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-register"]) return;
  try {
    
  class CustomerRegisterApp extends HTMLElement {
    connectedCallback() {
      this.passwordPattern = /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

      // Capture phase on this ancestor element runs before any listener
      // Shopify attaches directly to the submit button itself — including
      // its own hCaptcha bot-check script (auto-injected on classic
      // customer forms), which on classic accounts calls form.submit()
      // directly once its async challenge resolves. That bypasses the
      // 'submit' event entirely, so preventDefault() there can't stop it;
      // this has to intercept the click before hCaptcha's own handler runs.
      this.addEventListener(
        'click',
        (event) => {
          const submitButton = event.target.closest('.customer-auth__submit');
          if (!submitButton) return;

          this.splitName();
          this.syncBirthday();

          if (!this.validate()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        },
        { capture: true }
      );

      this.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-password-toggle]');
        if (toggle) {
          const input = toggle.parentElement.querySelector('[data-password-input]');
          if (input) {
            const isVisible = input.type === 'password';
            input.type = isVisible ? 'text' : 'password';
            toggle.querySelector('[data-icon-show]').toggleAttribute('hidden', isVisible);
            toggle.querySelector('[data-icon-hide]').toggleAttribute('hidden', !isVisible);
          }
        }
      });

      this.addEventListener('input', (event) => {
        if (event.target.matches('[data-birthday-display]')) {
          this.maskBirthday(event.target);
        }
        // Clears the red border for whichever field the visitor is fixing,
        // re-checked in full on the next submit attempt.
        const field = event.target.closest('.customer-auth__input');
        field?.classList.remove('is-invalid');
        this.updateBirthdayFeedback();
      });

      // Delegated on the custom element itself (submit bubbles) instead of
      // bound to a cached form reference — a direct reference grabbed in
      // connectedCallback can end up null if the browser upgrades/connects
      // this element before the parser has reached its <form> child, which
      // silently skipped the whole listener attachment.
      this.addEventListener('submit', (event) => {
        if (event.target.tagName !== 'FORM') return;

        this.splitName();
        this.syncBirthday();

        if (!this.validate()) {
          event.preventDefault();
        }
      });

      this.updateBirthdayFeedback();
    }

    // Fully custom validation (not native reportValidity/checkValidity) so
    // behavior is deterministic and doesn't depend on browser-specific
    // native-validation-bubble quirks. Fields are queried fresh here rather
    // than cached, for the same reason the submit listener is delegated.
    validate() {
      const fullNameInput = this.querySelector('[data-fullname-input]');
      const emailInput = this.querySelector('#CustomerEmail');
      const passwordInput = this.querySelector('[data-password-validate]');
      const birthdayInput = this.querySelector('[data-birthday-display]');
      const birthdayError = this.querySelector('[data-birthday-error]');

      let firstInvalid = null;
      const check = (input, isValid) => {
        const field = input?.closest('.customer-auth__input');
        field?.classList.toggle('is-invalid', !isValid);
        if (!isValid && !firstInvalid) firstInvalid = input;
        return isValid;
      };

      const nameValid = check(fullNameInput, !!fullNameInput?.value.trim());
      const emailValid = check(emailInput, !!emailInput?.value.trim() && emailInput.checkValidity());
      const passwordValid = check(passwordInput, this.passwordPattern.test(passwordInput?.value || ''));
      const birthdayDate = this.parseBirthday();
      const birthdayValid = check(birthdayInput, birthdayDate !== null);

      if (birthdayError) {
        birthdayError.hidden = birthdayValid || !birthdayInput.value;
      }

      firstInvalid?.focus();

      return nameValid && emailValid && passwordValid && birthdayValid;
    }

    splitName() {
      const fullNameInput = this.querySelector('[data-fullname-input]');
      const firstNameInput = this.querySelector('[data-first-name-input]');
      const lastNameInput = this.querySelector('[data-last-name-input]');
      if (!fullNameInput || !firstNameInput || !lastNameInput) return;

      const parts = fullNameInput.value.trim().split(/\s+/);
      firstNameInput.value = parts.shift() || '';
      lastNameInput.value = parts.join(' ');
    }

    maskBirthday(input) {
      let value = input.value.replace(/\D/g, '').slice(0, 8);
      if (value.length > 4) {
        value = `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4)}`;
      } else if (value.length > 2) {
        value = `${value.slice(0, 2)}/${value.slice(2)}`;
      }
      input.value = value;
    }

    syncBirthday() {
      const display = this.querySelector('[data-birthday-display]');
      const hidden = this.querySelector('[data-birthday-input]');
      if (!display || !hidden) return;

      const match = display.value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      hidden.value = match ? `${match[3]}-${match[2]}-${match[1]}` : '';
    }

    parseBirthday() {
      const value = this.querySelector('[data-birthday-display]')?.value || '';
      const match = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (!match) return null;

      const day = parseInt(match[1], 10);
      const month = parseInt(match[2], 10);
      const year = parseInt(match[3], 10);

      if (month < 1 || month > 12 || day < 1 || day > 31) return null;

      const date = new Date(year, month - 1, day);
      const isRealDate = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
      if (!isRealDate) return null;

      const now = new Date();
      const minYear = now.getFullYear() - 100;
      if (year < minYear || date > now) return null;

      return date;
    }

    updateBirthdayFeedback() {
      const birthdayError = this.querySelector('[data-birthday-error]');
      if (!birthdayError) return;

      const birthdayValue = this.querySelector('[data-birthday-display]')?.value || '';
      const birthdayComplete = birthdayValue.length === 10;
      const birthdayValid = birthdayComplete && this.parseBirthday() !== null;

      birthdayError.hidden = !(birthdayComplete && !birthdayValid);
    }
  }

  customElements.define('customer-register-app', CustomerRegisterApp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  class FaqAccordionList extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.faq-accordion__card'));
      this.cards.forEach((card) => {
        const button = card.querySelector('.faq-accordion__question');
        if (!button) return;
        button.addEventListener('click', () => this.toggle(card));
      });
    }

    toggle(card) {
      const wasOpen = card.classList.contains('is-open');

      this.cards.forEach((c) => {
        c.classList.remove('is-open');
        const button = c.querySelector('.faq-accordion__question');
        if (button) button.setAttribute('aria-expanded', 'false');
      });

      if (!wasOpen) {
        card.classList.add('is-open');
        const button = card.querySelector('.faq-accordion__question');
        if (button) button.setAttribute('aria-expanded', 'true');
      }
    }
  }

  customElements.define('faq-accordion-list', FaqAccordionList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  class FaqPageApp extends HTMLElement {
    connectedCallback() {
      this.categoryButtons = Array.from(this.querySelectorAll('.faq-page__category'));
      this.cards = Array.from(this.querySelectorAll('.faq-accordion__card'));
      this.headingEl = this.querySelector('[data-content-heading]');
      this.headingPrefix = this.headingEl ? this.headingEl.dataset.prefix || '' : '';

      this.categoryButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.selectCategory(button.dataset.category);
          if (button.id) history.replaceState(null, '', '#' + button.id);
        });
      });

      this.cards.forEach((card) => {
        const button = card.querySelector('.faq-accordion__question');
        if (button) button.addEventListener('click', () => this.toggleCard(card));
      });

      this.applyHash();
      window.addEventListener('hashchange', () => this.applyHash());
    }

    applyHash() {
      const hash = window.location.hash.replace('#', '');
      if (!hash) return;
      const button = this.categoryButtons.find((b) => b.id === hash);
      if (button) this.selectCategory(button.dataset.category);
    }

    selectCategory(category) {
      this.categoryButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.category === category);
      });

      this.cards.forEach((card) => {
        card.hidden = card.dataset.category !== category;
        card.classList.remove('is-open');
        const button = card.querySelector('.faq-accordion__question');
        if (button) button.setAttribute('aria-expanded', 'false');
      });

      if (this.headingEl) {
        this.headingEl.textContent = this.headingPrefix + category;
      }
    }

    toggleCard(card) {
      const wasOpen = card.classList.contains('is-open');

      this.cards.forEach((c) => {
        if (c.hidden) return;
        c.classList.remove('is-open');
        const button = c.querySelector('.faq-accordion__question');
        if (button) button.setAttribute('aria-expanded', 'false');
      });

      if (!wasOpen) {
        card.classList.add('is-open');
        const button = card.querySelector('.faq-accordion__question');
        if (button) button.setAttribute('aria-expanded', 'true');
      }
    }
  }

  customElements.define('faq-page-app', FaqPageApp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderMenu extends HTMLElement {
    connectedCallback() {
      const toggle = this.querySelector('.header__menu-toggle');
      const dialog = this.querySelector('.header__mobile-menu');
      const closeButton = this.querySelector('.header__mobile-menu-close');

      if (!toggle || !dialog) return;

      toggle.addEventListener('click', () => {
        dialog.showModal();
        requestAnimationFrame(() => dialog.classList.add('is-open'));
        toggle.setAttribute('aria-expanded', 'true');
      });

      const close = () => {
        dialog.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      };

      closeButton?.addEventListener('click', close);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) close();
      });
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        close();
      });
      dialog.addEventListener('transitionend', (event) => {
        if (event.propertyName === 'transform' && !dialog.classList.contains('is-open')) {
          dialog.close();
        }
      });

      const header = this.closest('header');
      const spacer = header.nextElementSibling;
      const mobileQuery = window.matchMedia('(max-width: 1140px)');
      let lastScrollY = window.scrollY;

      const initScrollBehavior = () => {
        // Only the announcement bar at the top of the page pushes the header
        // down (sections/announcement-bar.liquid).
        const announcement = document.querySelector(
          '.shopify-section-group-header-group + .shopify-section:not(.shopify-section-group-header-group) .announcement-bar'
        );

        const syncHeaderMetrics = () => {
          const height = `${header.offsetHeight}px`;
          if (spacer) spacer.style.height = height;
          document.documentElement.style.setProperty('--header-height', height);
        };

        const onScroll = () => {
          const currentScrollY = window.scrollY;
          const announcementMarginTop = announcement ? parseFloat(getComputedStyle(announcement).marginTop) || 0 : 0;
          const announcementHeight = announcement ? announcement.offsetHeight + announcementMarginTop : 0;
          header.style.top = `${Math.max(0, announcementHeight - currentScrollY)}px`;

          const scrollingDown = currentScrollY > lastScrollY;
          header.classList.toggle(
            'header--hidden',
            mobileQuery.matches && scrollingDown && currentScrollY > announcementHeight
          );

          lastScrollY = currentScrollY;
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', syncHeaderMetrics);
        syncHeaderMetrics();
        onScroll();
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initScrollBehavior);
      } else {
        initScrollBehavior();
      }
    }
  }

  customElements.define('header-menu', HeaderMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-hero-track]');
      this.slides = Array.from(this.querySelectorAll('.hero-slide'));
      this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
      this.index = 0;
      this.autoplayMs = parseInt(this.dataset.autoplay, 10) || 0;

      this.updateSlides();
      if (this.slides.length < 2) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.go(parseInt(dot.dataset.heroDot, 10)));
      });

      this.bindDrag();

      // Theme editor: show the selected banner and hold it there.
      this.onBlockSelect = (event) => {
        const index = this.slides.findIndex((slide) => event.target.contains(slide));
        if (index === -1) return;
        this.editorHold = true;
        this.go(index);
      };
      this.onBlockDeselect = () => {
        this.editorHold = false;
        this.restartAutoplay();
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

      this.restartAutoplay();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    go(index) {
      const count = this.slides.length;
      this.index = ((index % count) + count) % count;
      this.track.style.transform = `translateX(${-100 * this.index}%)`;
      this.updateSlides();
      this.restartAutoplay();
    }

    // Active dot, only the visible slide reachable by keyboard/screen
    // readers, and only its video playing.
    updateSlides() {
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        const blockEl = slide.parentElement === this.track ? slide : slide.parentElement;
        blockEl.inert = !active;
        blockEl.setAttribute('aria-hidden', active ? 'false' : 'true');

        const video = slide.querySelector('[data-hero-video]');
        if (!video) return;
        if (active) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });

      this.dots.forEach((dot, i) => {
        const active = i === this.index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    restartAutoplay() {
      clearTimeout(this.timer);
      if (!this.autoplayMs || this.slides.length < 2 || this.editorHold) return;
      this.timer = setTimeout(() => this.go(this.index + 1), this.autoplayMs);
    }

    // Swipe (touch) and drag (mouse) via pointer events. Vertical scrolling
    // stays native thanks to touch-action: pan-y on the track.
    bindDrag() {
      let startX = 0;
      let deltaX = 0;
      let pointerId = null;
      this.dragged = false;

      this.track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        deltaX = 0;
        this.dragged = false;
        clearTimeout(this.timer);
      });

      this.track.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointerId) return;
        deltaX = event.clientX - startX;
        if (!this.dragged && Math.abs(deltaX) > 8) {
          this.dragged = true;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(pointerId);
        }
        if (this.dragged) {
          this.track.style.transform = `translateX(calc(${-100 * this.index}% + ${deltaX}px))`;
        }
      });

      const end = (event) => {
        if (event.pointerId !== pointerId) return;
        pointerId = null;
        this.track.classList.remove('is-dragging');

        if (!this.dragged) {
          this.restartAutoplay();
          return;
        }
        // The click (if any) fires right after pointerup; clear the flag
        // afterwards so a later keyboard "click" isn't swallowed.
        setTimeout(() => { this.dragged = false; }, 0);
        const threshold = Math.min(80, this.offsetWidth * 0.15);
        if (deltaX <= -threshold) {
          this.go(this.index + 1);
        } else if (deltaX >= threshold) {
          this.go(this.index - 1);
        } else {
          this.go(this.index);
        }
      };
      this.track.addEventListener('pointerup', end);
      this.track.addEventListener('pointercancel', end);

      // No native link/image drag ghost while dragging with the mouse.
      this.track.addEventListener('dragstart', (event) => event.preventDefault());

      // A drag that ends over the button/link must not also click it.
      this.track.addEventListener('click', (event) => {
        if (!this.dragged) return;
        event.preventDefault();
        event.stopPropagation();
        this.dragged = false;
      }, true);
    }
  }

  if (!customElements.get('hero-slider')) {
    customElements.define('hero-slider', HeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  class HowItWorksSteps extends HTMLElement {
    connectedCallback() {
      this.steps = Array.from(this.querySelectorAll('.how-it-works__step'));
      this.triggers = Array.from(this.querySelectorAll('.how-it-works__trigger'));

      if (!this.steps.length || !this.triggers.length) return;
      if (window.matchMedia('(max-width: 749px)').matches) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.setActiveStep(entry.target.dataset.step);
          }
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });

      this.triggers.forEach((trigger) => observer.observe(trigger));
    }

    setActiveStep(step) {
      this.steps.forEach((el) => {
        el.classList.toggle('is-active', el.dataset.step === step);
      });
    }
  }

  customElements.define('how-it-works-steps', HowItWorksSteps);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-quote"] && !Shopify.designMode) return;
  try {
    
  class PressLogosMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.press-quote__logos-track');
      if (!this.track) return;

      this.originalItems = Array.from(this.track.children);
      this.originalCount = this.originalItems.length;
      if (!this.originalCount) return;

      this.offset = 0;
      this.loopDistance = 0;
      this.speed = 0;
      this.lastTime = null;
      this.paused = false;

      this.fillTrack();
      this.measure();

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.fillTrack();
          this.measure();
        });
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.track);
      }

      this.addEventListener('mouseenter', () => { this.paused = true; });
      this.addEventListener('mouseleave', () => { this.paused = false; });

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reducedMotion) {
        this.boundTick = this.tick.bind(this);
        requestAnimationFrame(this.boundTick);
      }
    }

    fillTrack() {
      const containerWidth = this.getBoundingClientRect().width;
      if (!containerWidth) return;

      let guard = 0;
      while (
        (this.track.children.length < this.originalCount * 2 || this.track.scrollWidth < containerWidth * 2)
        && guard < 20
      ) {
        this.originalItems.forEach((item) => {
          const clone = item.cloneNode(true);
          this.stripEditorAttributes(clone);
          clone.setAttribute('aria-hidden', 'true');
          this.track.appendChild(clone);
        });
        guard++;
      }
    }

    stripEditorAttributes(el) {
      if (el.attributes) {
        Array.from(el.attributes).forEach((attr) => {
          if (attr.name === 'id' || attr.name.indexOf('data-') === 0) {
            el.removeAttribute(attr.name);
          }
        });
      }
      Array.from(el.children || []).forEach((child) => this.stripEditorAttributes(child));
    }

    measure() {
      const items = Array.from(this.track.children).map((wrapper) => wrapper.firstElementChild || wrapper);
      const firstItem = items[0];
      const firstClone = items[this.originalCount];
      if (!firstItem || !firstClone) return;

      const distance = firstClone.getBoundingClientRect().left - firstItem.getBoundingClientRect().left;
      if (distance > 0 && distance !== this.loopDistance) {
        this.loopDistance = distance;
        this.speed = this.loopDistance / 14000;
        this.offset = (((this.offset % this.loopDistance) + this.loopDistance) % this.loopDistance) - this.loopDistance;
        this.track.style.transform = `translateX(${this.offset}px)`;
      }
    }

    tick(time) {
      if (this.lastTime === null) this.lastTime = time;
      const delta = time - this.lastTime;
      this.lastTime = time;

      if (!this.paused && this.loopDistance > 0) {
        this.offset -= this.speed * delta;
        if (this.offset <= -this.loopDistance) this.offset += this.loopDistance;
        this.track.style.transform = `translateX(${this.offset}px)`;
      }

      requestAnimationFrame(this.boundTick);
    }
  }

  customElements.define('press-logos-marquee', PressLogosMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-animated-text"] && !Shopify.designMode) return;
  try {
    
  class AnimatedTextFill extends HTMLElement {
    connectedCallback() {
      this.letters = Array.from(this.querySelectorAll('.product-animated-text__letter'));
      if (!this.letters.length) return;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.reducedMotion) {
        this.letters.forEach((letter) => letter.classList.add('is-filled'));
        return;
      }

      this.ticking = false;
      this.boundRequestUpdate = this.requestUpdate.bind(this);
      this.boundUpdate = this.update.bind(this);

      window.addEventListener('scroll', this.boundRequestUpdate, { passive: true });
      window.addEventListener('resize', this.boundRequestUpdate);
      this.update();
    }

    requestUpdate() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(this.boundUpdate);
    }

    update() {
      this.ticking = false;
      const rect = this.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      const start = viewportHeight * 0.85;
      const end = viewportHeight * 0.35;
      const progress = (start - rect.top) / (start - end);
      const clamped = Math.min(1, Math.max(0, progress));
      const filledCount = Math.round(clamped * this.letters.length);

      this.letters.forEach((letter, i) => {
        letter.classList.toggle('is-filled', i < filledCount);
      });
    }

    disconnectedCallback() {
      if (this.reducedMotion) return;
      window.removeEventListener('scroll', this.boundRequestUpdate);
      window.removeEventListener('resize', this.boundRequestUpdate);
    }
  }

  customElements.define('animated-text-fill', AnimatedTextFill);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-how-it-works"] && !Shopify.designMode) return;
  try {
    
  class ProductHowItWorksTimeline extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.timed-accordion__item'));
      if (!this.items.length) return;

      this.distributeMedia();

      this.index = 0;
      this.started = false;

      this.items.forEach((item, i) => {
        const title = item.querySelector('.timed-accordion__item-title');
        if (title) title.addEventListener('click', () => this.activate(i));
      });

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.started) {
            this.started = true;
            this.activate(0, reducedMotion);
            observer.disconnect();
          }
        });
      }, { threshold: 0.3 });
      observer.observe(this);
    }

    // Each timed-step block may carry its own hidden image slide — this
    // moves those into the media column, keyed to the same index as
    // this.items, so activate() can show the right one alongside the text.
    distributeMedia() {
      const mediaContainer = this.querySelector('[data-media]');
      this.defaultMedia = this.querySelector('[data-media-default]');

      this.mediaSlides = this.items.map((item) => {
        const slide = item.querySelector('[data-media-slide]');
        if (!slide || !mediaContainer) return null;
        slide.hidden = false;
        mediaContainer.appendChild(slide);
        return slide;
      });
    }

    activate(index, reducedMotion) {
      clearTimeout(this.timer);
      this.index = index;

      this.items.forEach((item, i) => {
        item.classList.toggle('is-active', i === index);
        const fill = item.querySelector('.timed-accordion__timer-fill');
        if (fill) {
          fill.style.transition = 'none';
          fill.style.width = '0%';
        }
      });

      if (this.mediaSlides) {
        const activeSlide = this.mediaSlides[index];
        this.mediaSlides.forEach((slide) => {
          if (slide) slide.classList.toggle('is-active', slide === activeSlide);
        });
        if (this.defaultMedia) this.defaultMedia.classList.toggle('is-active', !activeSlide);
      }

      const active = this.items[index];
      const duration = (parseFloat(active.dataset.duration) || 6) * 1000;
      const fill = active.querySelector('.timed-accordion__timer-fill');

      if (fill && !reducedMotion) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            fill.style.transition = `width ${duration}ms linear`;
            fill.style.width = '100%';
          });
        });
      } else if (fill) {
        fill.style.width = '100%';
      }

      this.timer = setTimeout(() => {
        this.activate((this.index + 1) % this.items.length, reducedMotion);
      }, duration);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }
  }

  customElements.define('product-how-it-works-timeline', ProductHowItWorksTimeline);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-how-to-take"] && !Shopify.designMode) return;
  try {
    
  class ProductHowToTakeTimeline extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.timed-accordion__item'));
      if (!this.items.length) return;

      this.index = 0;
      this.started = false;

      this.items.forEach((item, i) => {
        const title = item.querySelector('.timed-accordion__item-title');
        if (title) title.addEventListener('click', () => this.activate(i));
      });

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.started) {
            this.started = true;
            this.activate(0, reducedMotion);
            observer.disconnect();
          }
        });
      }, { threshold: 0.3 });
      observer.observe(this);
    }

    activate(index, reducedMotion) {
      clearTimeout(this.timer);
      this.index = index;

      this.items.forEach((item, i) => {
        item.classList.toggle('is-active', i === index);
        const fill = item.querySelector('.timed-accordion__timer-fill');
        if (fill) {
          fill.style.transition = 'none';
          fill.style.width = '0%';
        }
      });

      const active = this.items[index];
      const duration = (parseFloat(active.dataset.duration) || 6) * 1000;
      const fill = active.querySelector('.timed-accordion__timer-fill');

      if (fill && !reducedMotion) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            fill.style.transition = `width ${duration}ms linear`;
            fill.style.width = '100%';
          });
        });
      } else if (fill) {
        fill.style.width = '100%';
      }

      this.timer = setTimeout(() => {
        this.activate((this.index + 1) % this.items.length, reducedMotion);
      }, duration);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }
  }

  customElements.define('product-how-to-take-timeline', ProductHowToTakeTimeline);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients"] && !Shopify.designMode) return;
  try {
    
  class IngredientAccordionList extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.ingredient-item'));
      this.items.forEach((item) => {
        const button = item.querySelector('.ingredient-item__question');
        if (!button) return;
        button.addEventListener('click', () => this.toggle(item));
      });
    }

    toggle(item) {
      const wasOpen = item.classList.contains('is-open');

      this.items.forEach((el) => {
        el.classList.remove('is-open');
        const button = el.querySelector('.ingredient-item__question');
        if (button) button.setAttribute('aria-expanded', 'false');
      });

      if (!wasOpen) {
        item.classList.add('is-open');
        const button = item.querySelector('.ingredient-item__question');
        if (button) button.setAttribute('aria-expanded', 'true');
      }
    }
  }

  customElements.define('ingredient-accordion-list', IngredientAccordionList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-listing"] && !Shopify.designMode) return;
  try {
    
  class ProductListing extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const chevron = event.target.closest('.product-card__variant-chevron');
        if (chevron) {
          this.stepVariant(chevron.closest('.product-card'), chevron.dataset.direction);
        }
      });
    }

    stepVariant(card, direction) {
      if (!card) {
        return;
      }

      const rows = Array.from(card.querySelectorAll('.product-card__variant-mobile'));
      if (!rows.length) {
        return;
      }

      const currentIndex = rows.findIndex((row) => row.classList.contains('is-active'));
      const delta = direction === 'next' ? 1 : -1;
      const nextIndex = (currentIndex + delta + rows.length) % rows.length;

      rows.forEach((row, index) => row.classList.toggle('is-active', index === nextIndex));
    }
  }

  customElements.define('product-listing', ProductListing);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-picker"] && !Shopify.designMode) return;
  try {
    
  class ProductPicker extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('.product-picker__tab');
        if (tab) {
          this.activateProduct(tab.dataset.target);
          return;
        }

        const chevron = event.target.closest('.product-card__variant-chevron');
        if (chevron) {
          this.stepVariant(chevron.closest('.product-card'), chevron.dataset.direction);
        }
      });

      this.buildTabs();

      this.grid = this.querySelector('.product-picker__grid');
      if (this.grid && this.grid.children.length > 1) {
        this.gridQuery = window.matchMedia('(min-width: 750px)');
        new ResizeObserver(() => this.updateGridLayout()).observe(this.grid);
      }
    }

    buildTabs() {
      const tabsContainer = this.querySelector('[data-tabs]');
      const cards = Array.from(this.querySelectorAll('.product-card'));
      
      if (!tabsContainer || cards.length < 2) {
        return;
      }

      cards.forEach((card, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'product-picker__tab' + (index === 0 ? ' is-active' : '');
        button.setAttribute('role', 'tab');
        button.dataset.target = card.id;
        button.textContent = card.dataset.tabLabel || '';
        tabsContainer.appendChild(button);
      });
    }

    naturalCardWidth(card) {
      const clone = card.cloneNode(true);
      clone.removeAttribute('id');
      clone.style.position = 'absolute';
      clone.style.visibility = 'hidden';
      clone.style.width = 'auto';
      clone.style.maxWidth = 'none';
      document.body.appendChild(clone);
      const width = clone.getBoundingClientRect().width;
      document.body.removeChild(clone);
      return width;
    }

    updateGridLayout() {
      if (!this.gridQuery.matches) {
        this.grid.classList.remove('product-picker__grid--stacked');
        return;
      }

      const cards = Array.from(this.grid.querySelectorAll('.product-card'));
      const gap = parseFloat(getComputedStyle(this.grid).columnGap) || 0;
      const neededWidth = cards.reduce((sum, card) => sum + this.naturalCardWidth(card), 0) + gap * (cards.length - 1);

      this.grid.classList.toggle('product-picker__grid--stacked', neededWidth > this.grid.clientWidth);
    }

    activateProduct(targetId) {
      this.querySelectorAll('.product-picker__tab').forEach((tab) => {
        tab.classList.toggle('is-active', tab.dataset.target === targetId);
      });
      this.querySelectorAll('.product-card').forEach((card) => {
        card.classList.toggle('is-active', card.id === targetId);
      });
    }

    stepVariant(card, direction) {
      if (!card) return;

      const rows = Array.from(card.querySelectorAll('.product-card__variant-mobile'));
      if (!rows.length) return;

      const currentIndex = rows.findIndex((row) => row.classList.contains('is-active'));
      const delta = direction === 'next' ? 1 : -1;
      const nextIndex = (currentIndex + delta + rows.length) % rows.length;

      rows.forEach((row, index) => row.classList.toggle('is-active', index === nextIndex));
    }
  }

  customElements.define('product-picker', ProductPicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-quantity"] && !Shopify.designMode) return;
  try {
    
  class ProductQuantityApp extends HTMLElement {
    connectedCallback() {
      this.initCarousel();
      this.initForm();
    }

    initCarousel() {
      this.slides = Array.from(this.querySelectorAll('.product-quantity__slide'));
      this.dots = Array.from(this.querySelectorAll('.product-quantity__dot'));
      if (!this.slides.length) return;

      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === 0));
      this.slideIndex = 0;

      if (this.slides.length <= 1) return;

      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goToSlide(i)));

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reducedMotion) this.startCarousel();
    }

    startCarousel() {
      clearInterval(this.carouselInterval);
      this.carouselInterval = setInterval(() => {
        this.goToSlide((this.slideIndex + 1) % this.slides.length);
      }, 5000);
    }

    goToSlide(index) {
      this.slideIndex = index;
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      this.startCarousel();
    }

    disconnectedCallback() {
      clearInterval(this.carouselInterval);
    }

    initForm() {
      this.form = this.querySelector('[data-quantity-cart-form]');
      this.purchaseLink = '';
      if (this.form) {
        this.form.addEventListener('submit', (event) => {
          if (this.purchaseLink) {
            event.preventDefault();
            window.location.href = this.purchaseLink;
          }
        });
      }

      this.options = Array.from(this.querySelectorAll('[data-option]'));
      this.continueBtn = this.querySelector('[data-continue]');
      this.finishBtn = this.querySelector('[data-finish]');
      this.step1 = this.querySelector('[data-step="1"]');
      this.step2 = this.querySelector('[data-step="2"]');
      this.selectedNameEl = this.querySelector('[data-selected-name]');
      this.qtyLabel = this.querySelector('[data-qty-label]');
      this.qtyDecrease = this.querySelector('[data-qty-decrease]');
      this.qtyIncrease = this.querySelector('[data-qty-increase]');
      this.purchaseOptions = Array.from(this.querySelectorAll('[data-purchase]'));
      this.variantInput = this.querySelector('[data-variant-input]');
      this.sellingPlanInput = this.querySelector('[data-selling-plan-input]');

      this.selected = null;
      this.qty = 1;
      this.availablePacks = [...new Set(this.options.map((o) => parseInt(o.dataset.packs, 10)))]
        .filter((n) => !isNaN(n))
        .sort((a, b) => a - b);

      this.options.forEach((option) => {
        option.addEventListener('click', () => this.selectOption(option));
      });

      if (this.qtyDecrease) this.qtyDecrease.addEventListener('click', () => this.changeQty(-1));
      if (this.qtyIncrease) this.qtyIncrease.addEventListener('click', () => this.changeQty(1));
      if (this.continueBtn) this.continueBtn.addEventListener('click', () => this.goToStep2());

      this.purchaseOptions.forEach((option) => {
        option.addEventListener('click', () => this.selectPurchase(option));
      });
    }

    selectOption(option) {
      this.options.forEach((o) => {
        o.classList.remove('is-selected');
        const input = o.querySelector('input[type="radio"]');
        if (input) input.checked = false;
      });

      option.classList.add('is-selected');
      const input = option.querySelector('input[type="radio"]');
      if (input) input.checked = true;
      this.selected = option;

      if (this.continueBtn) {
        this.continueBtn.disabled = false;
        this.continueBtn.classList.add('is-active');
      }
    }

    // The +/- stepper is the only way to switch between celebration options
    // once on step 2 (there's no back button in this layout), so it moves
    // between the actual configured packs-per-week values — not a free
    // count — and re-selects the matching option each time it moves.
    changeQty(delta) {
      const currentIndex = this.availablePacks.indexOf(this.qty);
      const nextIndex = currentIndex + delta;
      if (nextIndex < 0 || nextIndex >= this.availablePacks.length) return;

      this.qty = this.availablePacks[nextIndex];
      this.updateQtyLabel();

      const matchingOption = this.options.find((o) => parseInt(o.dataset.packs, 10) === this.qty);
      if (matchingOption) {
        this.selected = matchingOption;
        this.updatePurchaseDisplay();
      }
    }

    updateQtyLabel() {
      if (this.qtyLabel) {
        this.qtyLabel.textContent = `${this.qty} ${this.qty > 1 ? 'Packs' : 'Pack'} por semana`;
      }
      const currentIndex = this.availablePacks.indexOf(this.qty);
      if (this.qtyDecrease) this.qtyDecrease.disabled = currentIndex <= 0;
      if (this.qtyIncrease) this.qtyIncrease.disabled = currentIndex >= this.availablePacks.length - 1;
    }

    goToStep2() {
      if (!this.selected || this.continueBtn.disabled) return;

      this.qty = parseInt(this.selected.dataset.packs, 10) || 1;
      this.updateQtyLabel();
      this.updatePurchaseDisplay();

      this.purchaseOptions.forEach((option) => {
        option.classList.remove('is-selected');
        const input = option.querySelector('input[type="radio"]');
        if (input) input.checked = false;
      });

      if (this.finishBtn) {
        this.finishBtn.disabled = true;
        this.finishBtn.classList.remove('is-active');
      }
      if (this.sellingPlanInput) this.sellingPlanInput.disabled = true;

      if (this.step1) this.step1.classList.remove('is-active');
      if (this.step2) this.step2.classList.add('is-active');
    }

    // Refreshes both purchase cards' price/description for whichever
    // celebration option is currently selected, and — if a purchase mode is
    // already chosen — keeps the hidden cart inputs pointed at that option's
    // product instead of a stale one from before the stepper moved.
    updatePurchaseDisplay() {
      if (!this.selected) return;

      if (this.selectedNameEl) this.selectedNameEl.textContent = this.selected.dataset.name || '';

      this.purchaseOptions.forEach((option) => {
        if (option.dataset.purchase === 'subscription') {
          const priceEl = option.querySelector('[data-sub-price]');
          const descEl = option.querySelector('[data-sub-desc]');
          const price = parseInt(this.selected.dataset.subPrice, 10) || 0;
          const discount = parseInt(this.selected.dataset.discountPercent, 10) || 0;
          const extra = this.selected.dataset.subExtra || '';
          if (priceEl) priceEl.textContent = this.formatMoney(price);
          if (descEl) {
            descEl.textContent = discount > 0
              ? `${discount}% OFF${extra ? ' + ' + extra : ''}`
              : extra;
          }
        } else {
          const priceEl = option.querySelector('[data-one-time-price]');
          const descEl = option.querySelector('[data-one-time-desc]');
          const price = parseInt(this.selected.dataset.oneTimePrice, 10) || 0;
          if (priceEl) priceEl.textContent = this.formatMoney(price);
          if (descEl) descEl.textContent = this.selected.dataset.oneTimeDesc || '';
        }
      });

      const checkedPurchase = this.purchaseOptions.find((o) => o.classList.contains('is-selected'));
      if (checkedPurchase) this.syncCartInputs(checkedPurchase);
    }

    selectPurchase(option) {
      this.purchaseOptions.forEach((o) => {
        o.classList.remove('is-selected');
        const input = o.querySelector('input[type="radio"]');
        if (input) input.checked = false;
      });

      option.classList.add('is-selected');
      const input = option.querySelector('input[type="radio"]');
      if (input) input.checked = true;

      if (this.finishBtn) {
        this.finishBtn.disabled = false;
        this.finishBtn.classList.add('is-active');
      }

      this.syncCartInputs(option);
    }

    syncCartInputs(option) {
      const isSubscription = option.dataset.purchase === 'subscription';

      if (this.variantInput) {
        this.variantInput.value = isSubscription
          ? (this.selected.dataset.subVariantId || '')
          : (this.selected.dataset.oneTimeVariantId || '');
      }

      if (this.sellingPlanInput) {
        const sellingPlan = isSubscription ? (this.selected.dataset.sellingPlan || '') : '';
        this.sellingPlanInput.value = sellingPlan;
        this.sellingPlanInput.disabled = !sellingPlan;
      }

      this.purchaseLink = isSubscription
        ? (this.selected.dataset.subPurchaseLink || '')
        : (this.selected.dataset.oneTimePurchaseLink || '');
    }

    formatMoney(cents) {
      return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
  }

  customElements.define('product-quantity-app', ProductQuantityApp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-science"] && !Shopify.designMode) return;
  try {
    
  class ProductScienceTimeline extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.timed-accordion__item'));
      if (!this.items.length) return;

      this.distributeMedia();

      this.index = 0;
      this.started = false;

      this.items.forEach((item, i) => {
        const title = item.querySelector('.timed-accordion__item-title');
        if (title) title.addEventListener('click', () => this.activate(i));
      });

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.started) {
            this.started = true;
            this.activate(0, reducedMotion);
            observer.disconnect();
          }
        });
      }, { threshold: 0.3 });
      observer.observe(this);
    }

    // Each timed-step block may carry its own hidden image slide — this
    // moves those into the media column, keyed to the same index as
    // this.items, so activate() can show the right one alongside the text.
    distributeMedia() {
      const mediaContainer = this.querySelector('[data-media]');
      this.defaultMedia = this.querySelector('[data-media-default]');

      this.mediaSlides = this.items.map((item) => {
        const slide = item.querySelector('[data-media-slide]');
        if (!slide || !mediaContainer) return null;
        slide.hidden = false;
        mediaContainer.appendChild(slide);
        return slide;
      });
    }

    activate(index, reducedMotion) {
      clearTimeout(this.timer);
      this.index = index;

      this.items.forEach((item, i) => {
        item.classList.toggle('is-active', i === index);
        const fill = item.querySelector('.timed-accordion__timer-fill');
        if (fill) {
          fill.style.transition = 'none';
          fill.style.width = '0%';
        }
      });

      if (this.mediaSlides) {
        const activeSlide = this.mediaSlides[index];
        this.mediaSlides.forEach((slide) => {
          if (slide) slide.classList.toggle('is-active', slide === activeSlide);
        });
        if (this.defaultMedia) this.defaultMedia.classList.toggle('is-active', !activeSlide);
      }

      const active = this.items[index];
      const duration = (parseFloat(active.dataset.duration) || 6) * 1000;
      const fill = active.querySelector('.timed-accordion__timer-fill');

      if (fill && !reducedMotion) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            fill.style.transition = `width ${duration}ms linear`;
            fill.style.width = '100%';
          });
        });
      } else if (fill) {
        fill.style.width = '100%';
      }

      this.timer = setTimeout(() => {
        this.activate((this.index + 1) % this.items.length, reducedMotion);
      }, duration);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }
  }

  customElements.define('product-science-timeline', ProductScienceTimeline);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-waitlist"] && !Shopify.designMode) return;
  try {
    
  class BenefitsMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.product-waitlist__benefits-track');
      if (!this.track) return;

      this.originalItems = Array.from(this.track.children);
      this.originalCount = this.originalItems.length;
      if (!this.originalCount) return;

      this.offset = 0;
      this.loopDistance = 0;
      this.speed = 0;
      this.lastTime = null;
      this.paused = false;

      this.fillTrack();
      this.measure();

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.fillTrack();
          this.measure();
        });
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.track);
      }

      this.addEventListener('mouseenter', () => { this.paused = true; });
      this.addEventListener('mouseleave', () => { this.paused = false; });

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reducedMotion) {
        this.boundTick = this.tick.bind(this);
        requestAnimationFrame(this.boundTick);
      }
    }

    fillTrack() {
      const containerWidth = this.getBoundingClientRect().width;
      if (!containerWidth) return;

      let guard = 0;
      while (
        (this.track.children.length < this.originalCount * 2 || this.track.scrollWidth < containerWidth * 2)
        && guard < 20
      ) {
        this.originalItems.forEach((item) => {
          const clone = item.cloneNode(true);
          this.stripEditorAttributes(clone);
          clone.setAttribute('aria-hidden', 'true');
          this.track.appendChild(clone);
        });
        guard++;
      }
    }

    stripEditorAttributes(el) {
      if (el.attributes) {
        Array.from(el.attributes).forEach((attr) => {
          if (attr.name === 'id' || attr.name.indexOf('data-') === 0) {
            el.removeAttribute(attr.name);
          }
        });
      }
      Array.from(el.children || []).forEach((child) => this.stripEditorAttributes(child));
    }

    measure() {
      const items = Array.from(this.track.children).map((wrapper) => wrapper.firstElementChild || wrapper);
      const firstItem = items[0];
      const firstClone = items[this.originalCount];
      if (!firstItem || !firstClone) return;

      const distance = firstClone.getBoundingClientRect().left - firstItem.getBoundingClientRect().left;
      if (distance > 0 && distance !== this.loopDistance) {
        this.loopDistance = distance;
        this.speed = this.loopDistance / 12000;
        this.offset = (((this.offset % this.loopDistance) + this.loopDistance) % this.loopDistance) - this.loopDistance;
        this.track.style.transform = `translateX(${this.offset}px)`;
      }
    }

    tick(time) {
      if (this.lastTime === null) this.lastTime = time;
      const delta = time - this.lastTime;
      this.lastTime = time;

      if (!this.paused && this.loopDistance > 0) {
        this.offset -= this.speed * delta;
        if (this.offset <= -this.loopDistance) this.offset += this.loopDistance;
        this.track.style.transform = `translateX(${this.offset}px)`;
      }

      requestAnimationFrame(this.boundTick);
    }
  }

  customElements.define('benefits-marquee', BenefitsMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.product-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.product-hero__dot'));
      if (this.slides.length <= 1) return;

      this.index = 0;
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.go(i));
      });

      this.bindSwipe();

      // Seconds per image set in the theme editor (0 = no automatic change).
      this.autoplayMs = parseInt(this.dataset.autoplay, 10) || 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.start();
    }

    start() {
      clearInterval(this.interval);
      if (!this.autoplayMs || this.reducedMotion) return;
      this.interval = setInterval(() => {
        this.go((this.index + 1) % this.slides.length);
      }, this.autoplayMs);
    }

    // Kit chosen in the buybox: jump to that kit's image, then keep rotating
    // from there as usual.
    showImage(imageId) {
      if (!imageId || !this.slides) return;
      const index = this.slides.findIndex((slide) => slide.dataset.imageId === String(imageId));
      if (index !== -1 && index !== this.index) this.go(index);
    }

    go(index) {
      this.index = index;
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      this.start();
    }

    // Swipe (touch) / drag (mouse) to the previous or next image. The slides
    // cross-fade, so this reacts on release instead of following the finger.
    bindSwipe() {
      const area = this.querySelector('.product-hero__slides');
      if (!area) return;
      this.classList.add('product-hero__gallery-inner--swipeable');

      let startX = 0;
      let startY = 0;
      let pointerId = null;

      area.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        clearInterval(this.interval);
        area.classList.add('is-dragging');
      });

      const end = (event) => {
        if (event.pointerId !== pointerId) return;
        pointerId = null;
        area.classList.remove('is-dragging');

        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;
        const count = this.slides.length;
        if (event.type !== 'pointercancel' && Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
          this.go(deltaX < 0 ? (this.index + 1) % count : (this.index - 1 + count) % count);
        } else {
          this.start();
        }
      };
      area.addEventListener('pointerup', end);
      area.addEventListener('pointercancel', end);
      area.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse' && pointerId !== null) end(event);
      });
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }
  }

  customElements.define('product-gallery', ProductGallery);

  class ProductBuybox extends HTMLElement {
    connectedCallback() {
      this.variants = {};
      this.querySelectorAll('[data-variant-payload]').forEach((script) => {
        try {
          const data = JSON.parse(script.textContent);
          this.variants[data.id] = data;
        } catch (e) {
          // ignore malformed payloads
        }
      });

      this.currentVariantId = this.dataset.currentVariant;
      this.purchaseMode = 'one_time';
      this.subscriptionRoute = this.dataset.subscriptionRoute || '';

      this.subscriptionCard = this.querySelector('[data-plan-option="subscription"]');
      this.oneTimeCard = this.querySelector('[data-plan-option="one_time"]');
      this.kitPills = Array.from(this.querySelectorAll('[data-kit-pills] [data-variant-id]'));

      this.discountEl = this.querySelector('[data-discount-percent]');
      this.subTotalEl = this.querySelector('[data-sub-total-price]');
      this.subDoseEl = this.querySelector('[data-sub-dose-price]');
      this.subDoseReferenceEl = this.querySelector('[data-sub-dose-reference]');
      this.oneTimeTotalEl = this.querySelector('[data-one-time-total-price]');
      this.oneTimeDoseEl = this.querySelector('[data-one-time-dose-price]');

      this.variantInput = this.querySelector('[data-variant-input]');
      this.returnToInput = this.querySelector('[data-return-to-input]');

      this.purchaseButton = this.querySelector('[data-purchase-button]');
      this.buttonLabelEl = this.querySelector('[data-button-label]');
      this.addToCartLabel = this.buttonLabelEl ? this.buttonLabelEl.textContent : '';
      this.subscribeLabel = this.dataset.subscribeLabel || this.addToCartLabel;

      // "Pix e parcelamento" theme settings (must mirror Yampi), passed in as
      // data attributes so nothing is hardcoded here.
      this.installmentsMax = parseInt(this.dataset.installmentsMax, 10) || 1;
      this.installmentMinCents = parseInt(this.dataset.installmentMinCents, 10) || 0;
      this.pixPercent = parseInt(this.dataset.pixPercent, 10) || 0;

      this.stickyBar = this.querySelector('[data-sticky-bar]');
      this.stickyButton = this.querySelector('[data-sticky-button]');
      this.stickyDiscountEl = this.querySelector('[data-sticky-discount-percent]');
      this.stickyTotalPriceEl = this.querySelector('[data-sticky-total-price]');
      this.stickyInstallmentPriceEl = this.querySelector('[data-sticky-installment-price]');
      this.stickyInstallmentEl = this.querySelector('[data-sticky-installment]');
      this.stickyInstallmentsCountEl = this.querySelector('[data-sticky-installments-count]');

      if (this.stickyButton) {
        this.stickyButton.addEventListener('click', () => {
          if (!this.stickyButton.disabled && this.purchaseButton) this.purchaseButton.click();
        });
      }

      this.kitPills.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (btn.disabled) return;
          const changed = btn.dataset.variantId !== String(this.currentVariantId);
          this.currentVariantId = btn.dataset.variantId;
          this.kitPills.forEach((b) => b.classList.toggle('is-active', b.dataset.variantId === btn.dataset.variantId));
          this.update();
          if (changed) {
            this.trackViewItem();
            this.showVariantImage();
          }
        });
      });

      [this.subscriptionCard, this.oneTimeCard].forEach((card) => {
        if (!card) return;
        card.addEventListener('click', () => {
          if (card.hidden) return;
          const previousMode = this.purchaseMode;
          this.purchaseMode = card.dataset.planOption;
          [this.subscriptionCard, this.oneTimeCard].forEach((c) => {
            if (!c) return;
            c.classList.toggle('is-selected', c === card);
            const input = c.querySelector('input[type="radio"]');
            if (input) input.checked = c === card;
          });
          this.syncCartInputs();
          // The card is a <label>, so one click fires this twice — only
          // track an actual change.
          if (previousMode !== this.purchaseMode) this.trackPurchaseType();
        });
      });

      if (this.purchaseButton) {
        this.purchaseButton.addEventListener('click', (event) => {
          if (this.purchaseMode === 'subscription' && this.subscriptionRoute) {
            event.preventDefault();
            window.location.href = this.subscriptionRoute;
            return;
          }
          if (!this.returnToInput) return;
          this.returnToInput.value =
            this.purchaseMode === 'subscription' ? '/checkout' : (this.returnToInput.dataset.cartUrl || '/cart');
        });
      }

      // The add is a native POST + page reload, which takes a moment: lock the
      // button(s) on the first submit so extra clicks don't add it twice.
      this.querySelector('[data-buybox-form]')?.addEventListener('submit', (event) => {
        if (this.submitting) {
          event.preventDefault();
          return;
        }
        this.submitting = true;
        if (this.purchaseMode === 'one_time') this.rememberAddToCart();

        // Not `disabled`: that style is the grey "sold out" look.
        this.purchaseButton?.classList.add('is-loading');
        this.stickyButton?.classList.add('is-loading');
        if (this.buttonLabelEl && this.purchaseMode === 'one_time') {
          this.buttonLabelEl.textContent = 'Adicionando...';
        }
      });

      // Coming back with the browser's back button can restore this page
      // from the bfcache with the buttons still locked.
      window.addEventListener('pageshow', (event) => {
        if (!event.persisted || !this.submitting) return;
        this.submitting = false;
        this.purchaseButton?.classList.remove('is-loading');
        this.stickyButton?.classList.remove('is-loading');
        this.syncCartInputs();
      });

      this.shippingDaysEl = this.querySelector('[data-shipping-days]');
      this.shippingPriceEl = this.querySelector('[data-shipping-price]');
      this.shippingSummaryEl = this.querySelector('[data-shipping-summary]');
      this.shippingErrorEl = this.querySelector('[data-shipping-error-message]');
      this.addEventListener('shipping-calculator:change', (event) => this.handleShippingResult(event.detail));

      this.update();

      // connectedCallback runs again whenever the buybox is re-created (e.g.
      // after adding to cart), so the page-load view_item is guarded on the
      // class itself — it outlives any instance until the page reloads.
      if (!ProductBuybox.viewItemTracked) {
        ProductBuybox.viewItemTracked = true;
        this.trackViewItem();
      }
    }

    showVariantImage() {
      const variant = this.variants[this.currentVariantId];
      const gallery = this.closest('.product-hero')?.querySelector('product-gallery');
      if (variant && gallery && typeof gallery.showImage === 'function') {
        gallery.showImage(variant.imageId);
      }
    }

    // P1 — view_item
    // Quando: ao carregar /products/pack e /products/bag — só 1x por
    // carregamento da página (e ao trocar o kit, atualizando item_variant/price).
    trackViewItem() {
      const variant = this.variants[this.currentVariantId];
      if (!variant || !window.NovvoTracking) {
        return;
      }

      const price = (variant.oneTimePrice || 0) / 100;
      window.NovvoTracking.pushEcommerce('view_item', {
        currency: window.NovvoTracking.currency,
        value: price,
        items: [{
          item_id: variant.sku || String(variant.id),
          item_name: this.dataset.productTitle,
          item_variant: variant.title,
          price,
          quantity: 1,
        }],
      });
    }

    // P1 — add_to_cart
    // Quando: 'Adicionar ao carrinho' (botão ou barra fixa) deu CERTO. O form
    // é um POST nativo que recarrega a página, então aqui só fica pendente;
    // o push sai quando a página volta com o drawer aberto e o /cart.js
    // confirma a variante (snippets/tracking-datalayer.liquid, "added:").
    // Assinatura não entra: vai direto pro checkout da Shopify.
    rememberAddToCart() {
      const variant = this.variants[this.currentVariantId];
      if (!variant || !window.NovvoTracking) return;

      const price = (variant.oneTimePrice || 0) / 100;
      window.NovvoTracking.setPending({
        event: 'add_to_cart',
        ecommerce: {
          currency: window.NovvoTracking.currency,
          value: price,
          items: [{
            item_id: variant.sku || String(variant.id),
            item_name: this.dataset.productTitle,
            item_variant: variant.title,
            price,
            quantity: 1,
          }],
        },
      }, 'added:' + variant.id);
    }

    // P2 — select_purchase_type
    // Quando: troca entre 'Comprar uma única vez' e 'Assine e economize'.
    trackPurchaseType() {
      if (!window.NovvoTracking) {
        return;
      }

      const payload = { event: 'select_purchase_type', purchase_type: this.purchaseMode };
      if (this.purchaseMode === 'subscription') {
        payload.discount_pct = parseInt(this.discountEl?.textContent, 10) || 0;
      }
      window.NovvoTracking.push(payload);
    }

    syncCartInputs() {
      const isSubscription = this.purchaseMode === 'subscription';

      if (this.purchaseButton) {
        this.purchaseButton.classList.toggle('is-subscription', isSubscription);
      }
      if (this.stickyBar) {
        this.stickyBar.classList.toggle('is-subscription', isSubscription);
      }
      if (this.buttonLabelEl) {
        this.buttonLabelEl.textContent =
          this.purchaseMode === 'subscription' ? this.subscribeLabel : this.addToCartLabel;
      }

      const variant = this.variants[this.currentVariantId];
      if (this.stickyButton && this.purchaseButton) {
        this.stickyButton.disabled = this.purchaseButton.disabled;
      }

      if (!this.variantInput) {
        return;
      }

      if (this.purchaseMode === 'subscription' && variant && variant.subscriptionVariantId) {
        this.variantInput.value = variant.subscriptionVariantId;
      } else {
        this.variantInput.value = this.currentVariantId;
      }

      // The shipping estimate simulates the item that would be added, so it
      // follows the chosen kit / purchase mode (it was stuck on the initial one).
      const calculator = this.querySelector('shipping-calculator');
      if (calculator && typeof calculator.setVariant === 'function') {
        calculator.setVariant(this.variantInput.value);
      }
    }

    update() {
      const variant = this.variants[this.currentVariantId];
      if (!variant) {
        return;
      }

      const hasSubscription = !!variant.hasSubscription;

      if (this.subscriptionCard) this.subscriptionCard.hidden = !hasSubscription;

      if (!hasSubscription) {
        this.purchaseMode = 'one_time';
        if (this.oneTimeCard) {
          this.oneTimeCard.classList.add('is-selected');
          const input = this.oneTimeCard.querySelector('input[type="radio"]');
          if (input) input.checked = true;
        }
        if (this.subscriptionCard) {
          this.subscriptionCard.classList.remove('is-selected');
          const input = this.subscriptionCard.querySelector('input[type="radio"]');
          if (input) input.checked = false;
        }
      } else if (!this.purchaseMode) {
        this.purchaseMode = 'subscription';
      }

      this.updatePrices();
      this.syncCartInputs();
    }

    updatePrices() {
      const variant = this.variants[this.currentVariantId];
      if (!variant) {
        return;
      }

      const numDoses = variant.numDoses || 1;
      const oneTimePrice = variant.oneTimePrice || 0;
      const oneTimeDosePrice = oneTimePrice / numDoses;

      if (this.oneTimeTotalEl) this.oneTimeTotalEl.textContent = this.formatMoney(oneTimePrice);
      if (this.oneTimeDoseEl) this.oneTimeDoseEl.textContent = this.formatMoney(oneTimeDosePrice);

      if (variant.hasSubscription) {
        const subTotalPrice = variant.subscriptionPrice || 0;
        const subDosePrice = subTotalPrice / numDoses;
        const discount = oneTimeDosePrice > 0
          ? Math.max(0, Math.round((1 - (subDosePrice / oneTimeDosePrice)) * 100))
          : 0;

        if (this.discountEl) this.discountEl.textContent = discount;
        if (this.stickyDiscountEl) this.stickyDiscountEl.textContent = discount;
        if (this.subTotalEl) this.subTotalEl.textContent = this.formatMoney(subTotalPrice);
        if (this.subDoseEl) this.subDoseEl.textContent = this.formatMoney(subDosePrice);
        if (this.subDoseReferenceEl) this.subDoseReferenceEl.textContent = this.formatMoney(oneTimeDosePrice);
      }

      // Sticky bar: Pix price (when enabled) + installments over the full price.
      const installments = this.installmentsFor(oneTimePrice);

      if (this.stickyTotalPriceEl) this.stickyTotalPriceEl.textContent = this.formatMoney(this.pixPrice(oneTimePrice));
      if (this.stickyInstallmentEl) this.stickyInstallmentEl.hidden = installments <= 1;
      if (this.stickyInstallmentsCountEl) this.stickyInstallmentsCountEl.textContent = installments;
      if (this.stickyInstallmentPriceEl) this.stickyInstallmentPriceEl.textContent = this.formatMoney(oneTimePrice / installments);
    }

    // Price with the Pix discount, in cents (rounded to keep whole cents).
    // pixPercent is 0 when the Pix price is turned off in the theme settings.
    pixPrice(cents) {
      return Math.round((cents * (100 - this.pixPercent)) / 100);
    }

    // Interest-free installments: min(max, floor(price / minimum installment)),
    // never below 1 — same rule as snippets/installments-count.liquid.
    installmentsFor(cents) {
      let count = this.installmentsMax;
      if (this.installmentMinCents > 0) {
        count = Math.min(count, Math.floor(cents / this.installmentMinCents));
      }
      return Math.max(1, count);
    }

    // "A partir de: X dias | R$ X,XX" — the fastest delivery estimate and
    // the cheapest rate, taken independently (they don't have to be the
    // same shipping method).
    handleShippingResult(detail) {
      if (!this.shippingSummaryEl) {
        return;
      }

      if (detail.error || !detail.rates || !detail.rates.length) {
        this.shippingSummaryEl.hidden = true;
        if (this.shippingErrorEl) {
          this.shippingErrorEl.textContent = detail.error || '';
          this.shippingErrorEl.hidden = !detail.error;
        }
        return;
      }

      if (this.shippingErrorEl) {
        this.shippingErrorEl.hidden = true;
      }

      let minDays = null;
      let minPrice = null;

      detail.rates.forEach((rate) => {
        const price = parseFloat(rate.price);
        if (!isNaN(price) && (minPrice === null || price < minPrice)) minPrice = price;

        if (Array.isArray(rate.delivery_range) && rate.delivery_range[0]) {
          const deliveryDate = new Date(rate.delivery_range[0]);
          const days = Math.max(1, Math.round((deliveryDate - new Date()) / 86400000));
          if (minDays === null || days < minDays) minDays = days;
        }
      });

      if (this.shippingDaysEl) {
        this.shippingDaysEl.textContent = minDays !== null ? `${minDays} ${minDays === 1 ? 'dia' : 'dias'}` : '—';
      }
      if (this.shippingPriceEl) {
        this.shippingPriceEl.textContent = minPrice !== null ? this.formatMoney(Math.round(minPrice * 100)) : '—';
      }

      this.shippingSummaryEl.hidden = false;
    }

    formatMoney(cents) {
      return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
  }

  customElements.define('product-buybox', ProductBuybox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["referral-signup"] && !Shopify.designMode) return;
  try {
    
  class ReferralSignupApp extends HTMLElement {
    connectedCallback() {
      this.addEventListener('submit', (event) => {
        const form = event.target.closest('form');
        if (!form) return;

        const fullNameInput = form.querySelector('[data-full-name]');
        const firstNameInput = form.querySelector('[data-first-name]');
        const lastNameInput = form.querySelector('[data-last-name]');
        if (!fullNameInput || !firstNameInput || !lastNameInput) return;

        const parts = fullNameInput.value.trim().split(/\s+/);
        firstNameInput.value = parts.shift() || '';
        lastNameInput.value = parts.join(' ');
      });
    }
  }

  customElements.define('referral-signup-app', ReferralSignupApp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reseller-carousel"] && !Shopify.designMode) return;
  try {
    
  class ResellerCarouselApp extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.reseller-carousel__track');
      if (!this.track) return;

      this.dragging = false;
      this.moved = false;

      // Mouse/pen drag only: on touch the track already scrolls natively
      // (overflow-x: auto), and scrolling it by hand as well made them fight.
      this.track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch' || event.button !== 0) return;
        // Keeps the browser from starting a text selection when the drag
        // begins over a card's title/text.
        event.preventDefault();
        this.dragging = true;
        this.moved = false;
        this.startX = event.clientX;
        this.startScroll = this.track.scrollLeft;
        this.classList.add('is-dragging');
      });

      window.addEventListener('pointermove', (event) => {
        if (!this.dragging) return;
        const delta = event.clientX - this.startX;
        if (Math.abs(delta) > 4) this.moved = true;
        this.track.scrollLeft = this.startScroll - delta;
      });

      const endDrag = () => {
        if (!this.dragging) return;
        this.dragging = false;
        this.classList.remove('is-dragging');
      };
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);
      window.addEventListener('blur', endDrag);

      // No native image/link drag ghost.
      this.track.addEventListener('dragstart', (event) => event.preventDefault());

      // Dragging a card shouldn't also trigger a click on it (e.g. if a
      // card becomes a link later).
      this.track.addEventListener(
        'click',
        (event) => {
          if (this.moved) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        true
      );
    }
  }

  customElements.define('reseller-carousel-app', ResellerCarouselApp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reseller-signup"] && !Shopify.designMode) return;
  try {
    
  class ResellerSignupApp extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-select-trigger]');
        if (trigger) {
          const group = trigger.closest('[data-custom-select]');
          const wasOpen = group.classList.contains('is-open');
          this.closeAllSelects();
          if (!wasOpen) this.openSelect(group);
          return;
        }

        const option = event.target.closest('.reseller-signup__select-option');
        if (option) {
          this.selectOption(option.closest('[data-custom-select]'), option);
          return;
        }

        if (!event.target.closest('[data-custom-select]')) {
          this.closeAllSelects();
        }
      });

      this.addEventListener('keydown', (event) => {
        const group = event.target.closest('[data-custom-select]');
        if (!group) return;
        if (event.target === group.querySelector('[data-select-trigger]') && event.key === 'Escape') {
          event.preventDefault();
          this.closeSelect(group);
        }
      });

      this.addEventListener('focusout', (event) => {
        const group = event.target.closest('[data-custom-select]');
        if (!group) return;
        requestAnimationFrame(() => {
          if (!group.contains(document.activeElement)) this.closeSelect(group);
        });
      });

      // Clear a field's error as soon as it's filled in.
      this.addEventListener('input', (event) => this.clearFieldError(event.target));
      this.addEventListener('change', (event) => this.clearFieldError(event.target));

      // Validated on the submit button's click (capture) as well as on
      // submit: Shopify's hCaptcha on native forms can call form.submit()
      // straight from the click, which never fires the 'submit' event.
      this.addEventListener('click', (event) => {
        const button = event.target.closest('.reseller-signup__submit');
        if (!button || !button.form) return;
        if (!this.prepare(button.form)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true });

      this.addEventListener('submit', (event) => {
        const form = event.target.closest('form');
        if (form && !this.prepare(form)) event.preventDefault();
      });
    }

    // Validates every visible field at once and, if all good, packs the
    // reseller-specific fields into the email body. Returns whether the
    // form can be sent.
    prepare(form) {
      const invalid = [];
      const isEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

      form.querySelectorAll('.reseller-signup__field, .reseller-signup__terms').forEach((field) => {
        const control = field.querySelector('input:not([type="hidden"]), select');
        if (!control) return;

        let message = '';
        if (control.type === 'checkbox') {
          if (control.required && !control.checked) message = 'Aceite os termos para continuar.';
        } else if (control.tagName === 'SELECT') {
          if (control.required && !control.value) message = 'Selecione uma opção.';
        } else {
          const value = control.value.trim();
          if (control.required && !value) {
            message = 'Preencha este campo.';
          } else if (control.type === 'email' && value && !isEmail(value)) {
            message = 'Digite um e-mail válido.';
          }
        }

        this.setFieldError(field, message);
        if (message) invalid.push(field);
      });

      const summary = form.querySelector('[data-form-error]');
      if (invalid.length) {
        if (summary) {
          summary.textContent = invalid.length === 1
            ? 'Falta 1 campo: confira o item destacado em vermelho.'
            : `Faltam ${invalid.length} campos: confira os itens destacados em vermelho.`;
          summary.hidden = false;
        }

        const first = invalid[0];
        const details = first.closest('details');
        if (details) details.open = true;
        this.closeAllSelects();
        first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const focusable = first.querySelector('[data-select-trigger]') || first.querySelector('input:not([type="hidden"])');
        if (focusable) focusable.focus({ preventScroll: true });
        return false;
      }

      if (summary) summary.hidden = true;
      this.buildBody(form);
      return true;
    }

    setFieldError(field, message) {
      field.classList.toggle('is-invalid', !!message);
      field.querySelector('[data-custom-select]')?.classList.toggle('is-invalid', !!message);

      let error = field.querySelector(':scope > .reseller-signup__error');
      if (!message) {
        error?.remove();
        return;
      }
      if (!error) {
        // <span>, not <p>: the terms row is a <label>.
        error = document.createElement('span');
        error.className = 'reseller-signup__error';
        field.appendChild(error);
      }
      error.textContent = message;
    }

    clearFieldError(control) {
      const field = control.closest?.('.reseller-signup__field, .reseller-signup__terms');
      if (field && field.classList.contains('is-invalid')) this.setFieldError(field, '');
    }

    // The reseller-specific fields go into the email body as text.
    buildBody(form) {
      const noteInput = form.querySelector('[data-note]');
      if (!noteInput) return;

      const get = (selector) => form.querySelector(selector)?.value.trim() || '';
      // Only the fields turned on in the theme editor ("Exibir campo").
      const lines = [
        ['[data-cnpj]', 'CNPJ'],
        ['[data-establishment]', 'Tipo de estabelecimento'],
        ['[data-state]', 'Estado'],
        ['[data-city]', 'Cidade'],
        ['[data-volume]', 'Volume estimado da 1ª compra'],
      ]
        .filter(([selector]) => form.querySelector(selector))
        .map(([selector, label]) => label + ': ' + get(selector));

      const brands = get('[data-brands]');
      const instagram = get('[data-instagram]');
      const storeCount = get('[data-store-count]');
      if (brands || instagram || storeCount) {
        lines.push('Prioridade na fila: sim');
        if (brands) lines.push('Marcas que já vende: ' + brands);
        if (instagram) lines.push('Instagram da loja: ' + instagram);
        if (storeCount) lines.push('Quantidade de lojas: ' + storeCount);
      }

      noteInput.value = lines.join('\n');
    }

    openSelect(group) {
      group.classList.add('is-open');
      group.querySelector('[data-select-trigger]').setAttribute('aria-expanded', 'true');
      group.querySelector('[data-select-list]').hidden = false;
    }

    closeSelect(group) {
      group.classList.remove('is-open');
      group.querySelector('[data-select-trigger]').setAttribute('aria-expanded', 'false');
      group.querySelector('[data-select-list]').hidden = true;
    }

    closeAllSelects() {
      this.querySelectorAll('[data-custom-select].is-open').forEach((group) => this.closeSelect(group));
    }

    selectOption(group, option) {
      const select = group.querySelector('[data-select-native]');
      const label = group.querySelector('[data-select-label]');
      const trigger = group.querySelector('[data-select-trigger]');

      select.value = option.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));

      label.textContent = option.textContent.trim();
      trigger.classList.remove('reseller-signup__select-trigger--placeholder');
      group.classList.remove('is-invalid');

      group.querySelectorAll('.reseller-signup__select-option').forEach((el) => {
        el.classList.toggle('is-selected', el === option);
      });

      this.closeSelect(group);
    }
  }

  customElements.define('reseller-signup-app', ResellerSignupApp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retailer-logos"] && !Shopify.designMode) return;
  try {
    
  class RetailerLogosMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.retailer-logos__track');
      if (!this.track) return;

      this.originalItems = Array.from(this.track.children);
      this.originalCount = this.originalItems.length;
      if (!this.originalCount) return;

      this.offset = 0;
      this.loopDistance = 0;
      this.speed = 0;
      this.lastTime = null;
      this.paused = false;

      this.fillTrack();
      this.measure();

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.fillTrack();
          this.measure();
        });
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.track);
      }

      this.addEventListener('mouseenter', () => { this.paused = true; });
      this.addEventListener('mouseleave', () => { this.paused = false; });

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reducedMotion) {
        this.boundTick = this.tick.bind(this);
        requestAnimationFrame(this.boundTick);
      }
    }

    fillTrack() {
      const containerWidth = this.getBoundingClientRect().width;
      if (!containerWidth) return;

      let guard = 0;
      while (
        (this.track.children.length < this.originalCount * 2 || this.track.scrollWidth < containerWidth * 2)
        && guard < 20
      ) {
        this.originalItems.forEach((item) => {
          const clone = item.cloneNode(true);
          this.stripEditorAttributes(clone);
          clone.setAttribute('aria-hidden', 'true');
          this.track.appendChild(clone);
        });
        guard++;
      }
    }

    stripEditorAttributes(el) {
      if (el.attributes) {
        Array.from(el.attributes).forEach((attr) => {
          if (attr.name === 'id' || attr.name.indexOf('data-') === 0) {
            el.removeAttribute(attr.name);
          }
        });
      }
      Array.from(el.children || []).forEach((child) => this.stripEditorAttributes(child));
    }

    measure() {
      const items = Array.from(this.track.children).map((wrapper) => wrapper.firstElementChild || wrapper);
      const firstItem = items[0];
      const firstClone = items[this.originalCount];
      if (!firstItem || !firstClone) return;

      const distance = firstClone.getBoundingClientRect().left - firstItem.getBoundingClientRect().left;
      if (distance > 0 && distance !== this.loopDistance) {
        this.loopDistance = distance;
        this.speed = this.loopDistance / 30000;
        this.offset = (((this.offset % this.loopDistance) + this.loopDistance) % this.loopDistance) - this.loopDistance;
        this.track.style.transform = `translateX(${this.offset}px)`;
      }
    }

    tick(time) {
      if (this.lastTime === null) this.lastTime = time;
      const delta = time - this.lastTime;
      this.lastTime = time;

      if (!this.paused && this.loopDistance > 0) {
        this.offset -= this.speed * delta;
        if (this.offset <= -this.loopDistance) this.offset += this.loopDistance;
        this.track.style.transform = `translateX(${this.offset}px)`;
      }

      requestAnimationFrame(this.boundTick);
    }
  }

  customElements.define('retailer-logos-marquee', RetailerLogosMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.reviews-carousel__track');
      if (!this.track) return;

      this.hydrateJudgeme();

      this.originalItems = Array.from(this.track.children);
      this.originalCount = this.originalItems.length;
      if (!this.originalCount) return;

      this.offset = 0;
      this.dragging = false;
      this.paused = false;
      this.lastTime = null;
      this.loopDistance = 0;
      this.speed = 0;

      this.fillTrack();
      this.measure();

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.fillTrack();
          this.measure();
        });
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.track);
      }

      this.boundTick = this.tick.bind(this);
      this.addEventListener('mouseenter', () => { this.paused = true; });
      this.addEventListener('mouseleave', () => { this.paused = false; });

      this.track.addEventListener('pointerdown', this.onPointerDown.bind(this));
      window.addEventListener('pointermove', this.onPointerMove.bind(this));
      window.addEventListener('pointerup', this.onPointerUp.bind(this));

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this.reducedMotion) {
        setTimeout(() => requestAnimationFrame(this.boundTick), 300);
      }
    }

    // Reads the raw Judge.me review markup (hidden, not styled/scripted by
    // Judge.me at all here) and rebuilds each review as a normal
    // .review-card node in the track, so this section always renders with
    // our own styling and carousel behavior regardless of whether
    // Judge.me's own widget script ever loads on the page.
    hydrateJudgeme() {
      const source = this.track.querySelector('[data-judgeme-source]');
      if (!source) return;

      source.querySelectorAll('.jdgm-carousel-item').forEach((item) => {
        const title = item.querySelector('.jdgm-carousel-item__review-title')?.textContent.trim() || '';
        const body = item.querySelector('.jdgm-carousel-item__review-body')?.textContent.trim() || '';
        const name = item.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent.trim() || '';
        const ratingEl = item.querySelector('.jdgm-carousel-item__review-rating');
        const rating = ratingEl ? ratingEl.querySelectorAll('.jdgm-star.jdgm--on').length : 5;

        this.track.appendChild(this.buildReviewCard({ rating, title, body, name }));
      });

      source.remove();
    }

    buildReviewCard({ rating, title, body, name }) {
      const card = document.createElement('div');
      card.className = 'review-card';

      const stars = document.createElement('div');
      stars.className = 'review-card__stars';
      for (let i = 0; i < 5; i++) {
        const star = document.createElement('span');
        star.className = 'review-card__star review-card__star--judgeme' + (i < rating ? ' is-on' : '');
        stars.appendChild(star);
      }
      card.appendChild(stars);

      if (title) {
        const heading = document.createElement('h3');
        heading.className = 'review-card__title';
        heading.textContent = title;
        card.appendChild(heading);
      }

      if (body) {
        const text = document.createElement('p');
        text.className = 'review-card__text';
        text.textContent = body;
        card.appendChild(text);
      }

      if (name) {
        const reviewer = document.createElement('span');
        reviewer.className = 'review-card__name';
        reviewer.textContent = name;
        card.appendChild(reviewer);
      }

      return card;
    }

    fillTrack() {
      const containerWidth = this.getBoundingClientRect().width;
      if (!containerWidth) return;

      let guard = 0;
      while (
        (this.track.children.length < this.originalCount * 2 || this.track.scrollWidth < containerWidth * 2)
        && guard < 20
      ) {
        this.originalItems.forEach((item) => {
          const clone = item.cloneNode(true);
          this.stripEditorAttributes(clone);
          clone.setAttribute('aria-hidden', 'true');
          this.track.appendChild(clone);
        });
        guard++;
      }
    }

    stripEditorAttributes(el) {
      if (el.attributes) {
        Array.from(el.attributes).forEach((attr) => {
          if (attr.name === 'id' || attr.name.indexOf('data-') === 0) {
            el.removeAttribute(attr.name);
          }
        });
      }
      Array.from(el.children || []).forEach((child) => this.stripEditorAttributes(child));
    }

    measure() {
      const items = Array.from(this.track.children).map((wrapper) => wrapper.firstElementChild || wrapper);
      const firstItem = items[0];
      const firstClone = items[this.originalCount];
      if (!firstItem || !firstClone) return;

      const distance = firstClone.getBoundingClientRect().left - firstItem.getBoundingClientRect().left;
      if (distance > 0 && distance !== this.loopDistance) {
        this.loopDistance = distance;
        // Fixed px/ms so the visual scroll speed stays the same no matter
        // how many cards there are — a loopDistance-based duration (e.g.
        // "always take 10s") makes it fly by once Judge.me brings in more
        // reviews than the handful of manual review-card blocks this was
        // originally tuned for.
        this.speed = 0.12;
        this.offset = (((this.offset % this.loopDistance) + this.loopDistance) % this.loopDistance) - this.loopDistance;
        this.render();
      }
    }

    tick(time) {
      if (this.lastTime === null) this.lastTime = time;
      const delta = time - this.lastTime;
      this.lastTime = time;

      if (!this.paused && !this.dragging && this.loopDistance > 0) {
        this.offset -= this.speed * delta;
        if (this.offset <= -this.loopDistance) this.offset += this.loopDistance;
        this.render();
      }

      requestAnimationFrame(this.boundTick);
    }

    render() {
      this.track.style.transform = `translateX(${this.offset}px)`;
    }

    onPointerDown(event) {
      event.preventDefault();
      this.dragging = true;
      this.dragStartX = event.clientX;
      this.dragStartOffset = this.offset;
      this.track.classList.add('is-dragging');
    }

    onPointerMove(event) {
      if (!this.dragging) return;
      const delta = event.clientX - this.dragStartX;
      this.offset = this.dragStartOffset + delta;

      if (this.loopDistance > 0) {
        while (this.offset <= -this.loopDistance) this.offset += this.loopDistance;
        while (this.offset > 0) this.offset -= this.loopDistance;
      }

      this.render();
    }

    onPointerUp() {
      if (!this.dragging) return;
      this.dragging = false;
      this.track.classList.remove('is-dragging');
    }
  }

  customElements.define('testimonials-carousel', TestimonialsCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-feature"] && !Shopify.designMode) return;
  try {
    
  class ScienceFeatureCarousel extends HTMLElement {
    connectedCallback() {
      this.posts = Array.from(this.querySelectorAll('.science-feature__post'));
      this.mediaItems = Array.from(this.querySelectorAll('.science-feature__media-item'));
      this.total = this.posts.length;
      if (this.total <= 1) return;

      this.index = 0;
      this.prevBtn = this.querySelector('[data-direction="prev"]');
      this.nextBtn = this.querySelector('[data-direction="next"]');
      this.currentEl = this.querySelector('.science-feature__nav-current');

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
      }

      this.update();
    }

    go(index) {
      if (index < 0 || index >= this.total) return;
      this.index = index;
      this.update();
    }

    update() {
      this.posts.forEach((el, i) => el.classList.toggle('is-active', i === this.index));
      this.mediaItems.forEach((el, i) => el.classList.toggle('is-active', i === this.index));

      if (this.currentEl) {
        this.currentEl.textContent = String(this.index + 1).padStart(2, '0');
      }
      if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.index === this.total - 1;
    }
  }

  customElements.define('science-feature-carousel', ScienceFeatureCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  class StoreLocatorApp extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-locator-form]');
      this.input = this.querySelector('[data-locator-input]');
      this.submit = this.querySelector('[data-locator-submit]');
      this.results = this.querySelector('[data-locator-results]');
      this.shipping = this.querySelector('.store-locator__shipping');
      this.stockistLoaded = false;
      this.watchStockistSearches();

      if (this.input) {
        this.input.addEventListener('input', () => this.updateSubmitState());
      }
      if (this.form) {
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.search();
        });
      }
      this.updateSubmitState();
    }

    updateSubmitState() {
      if (!this.submit) return;
      this.submit.disabled = !(this.input && this.input.value.trim());
    }

    search() {
      const value = this.input ? this.input.value.trim() : '';
      if (!value) return;

      if (this.results) this.results.hidden = false;
      this.awaitSearchResult(value);
      this.loadStockist(value);

      const digits = value.replace(/\D/g, '');
      if (this.shipping && typeof this.shipping.calculateFor === 'function') {
        if (digits.length === 8) {
          this.shipping.calculateFor(digits);
        } else if (typeof this.shipping.setError === 'function') {
          this.shipping.setError('Digite um CEP válido para calcular o frete.');
        }
      }
    }

    loadStockist(query) {
      if (!this.stockistLoaded) {
        // Read once by the widget when it first mounts.
        window.stockistStartingQuery = query;
        this.stockistLoaded = true;
        this.appendStockistScript();
        return;
      }

      // The widget has no public API to re-run a search after it has already
      // mounted, and rebuilding it from scratch doesn't reliably reinitialize
      // it either. So instead we drive its own already-rendered search field
      // and button — the same thing a shopper would do by hand. Its own
      // markup isn't necessarily nested inside our mount element (depending
      // on its config it can replace that element or insert its container
      // right before it), so this looks at the whole document, not this.mount.
      this.triggerStockistSearch(query);
    }

    triggerStockistSearch(query) {
      const field = document.querySelector('.stockist-search-field');
      const button = document.querySelector('.stockist-search-button button');
      if (!field || !button) return false;

      const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
      setter.call(field, query);
      field.dispatchEvent(new Event('input', { bubbles: true }));
      button.click();
      return true;
    }

    // P2 — store_locator_search
    // Quando: resultado de 'Ver disponibilidade' em /pages/onde-encontrar,
    // pushed once Stockist's own search request answers. The widget has no public events, so its fetch to
    // /api/v1/<tag>/locations/search (response: { locations: [...] }) is
    // observed instead. Only a CEP's first 3 digits are sent — never a typed
    // address.
    awaitSearchResult(query) {
      clearTimeout(this.pendingSearchTimer);
      const prefix = window.NovvoTracking?.cepPrefix(query);
      this.pendingSearch = (found) => {
        const payload = { event: 'store_locator_search' };
        if (prefix) payload.cep_prefix = prefix;
        payload.resultado_encontrado = found;
        window.NovvoTracking?.push(payload);
      };
      this.pendingSearchTimer = setTimeout(() => { this.pendingSearch = null; }, 15000);
    }

    watchStockistSearches() {
      if (window.__novvoStockistFetchWatched) return;
      window.__novvoStockistFetchWatched = true;

      const originalFetch = window.fetch;
      const app = this;
      window.fetch = function (input) {
        const request = originalFetch.apply(this, arguments);
        const url = typeof input === 'string' ? input : input?.url || String(input);

        if (/stockist\.co\/api\/v\d+\/[^/]+\/locations\/search/.test(url)) {
          request
            .then((response) => response.clone().json())
            .then((data) => {
              const resolve = app.pendingSearch;
              if (!resolve || !Array.isArray(data?.locations)) return;
              app.pendingSearch = null;
              clearTimeout(app.pendingSearchTimer);
              resolve(data.locations.length > 0);
            })
            .catch(() => {});
        }

        return request;
      };
    }

    appendStockistScript() {
      // Loads the Stockist widget (search + map + list) so it can build
      // itself — we don't restyle or restructure anything it renders.
      // https://help.stockist.co/article/24
      const script = document.createElement('script');
      script.src = '//stockist.co/embed/v1/widget.min.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }

  customElements.define('store-locator-app', StoreLocatorApp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-plan-picker"] && !Shopify.designMode) return;
  try {
    
  class SubscriptionPlanPicker extends HTMLElement {
    connectedCallback() {
      this.products = {};

      this.select = this.querySelector('[data-type-select]');
      this.kitContainer = this.querySelector('[data-kit-container]');

      Array.from(this.querySelectorAll('[data-product-option]')).forEach((el) => {
        const id = el.dataset.productId;
        const variants = {};

        el.querySelectorAll('[data-variant-payload]').forEach((script) => {
          try {
            const data = JSON.parse(script.textContent);
            variants[data.id] = data;
          } catch (e) {
            // ignore malformed payloads
          }
        });

        const pillsEl = el.querySelector('[data-product-pills]');
        if (pillsEl && this.kitContainer) this.kitContainer.appendChild(pillsEl);

        this.products[id] = {
          label: el.dataset.productLabel || '',
          image: el.dataset.productImage || '',
          imageAlt: el.dataset.productImageAlt || '',
          variants,
          pillsEl,
        };

        if (pillsEl) {
          Array.from(pillsEl.querySelectorAll('[data-variant-id]')).forEach((btn) => {
            btn.addEventListener('click', () => {
              if (btn.disabled) return;
              this.currentVariantId = btn.dataset.variantId;
              Array.from(pillsEl.querySelectorAll('[data-variant-id]')).forEach((b) => {
                b.classList.toggle('is-active', b === btn);
              });
              this.updatePrices();
            });
          });
        }

        if (this.select) {
          const option = document.createElement('option');
          option.value = id;
          option.textContent = this.products[id].label;
          this.select.appendChild(option);
        }
      });

      this.productOrder = Object.keys(this.products);
      this.currentProductId = null;
      this.currentVariantId = null;
      this.purchaseLink = '';

      this.routineCards = Array.from(this.querySelectorAll('[data-routine-card]'));
      this.panelImage = this.querySelector('[data-panel-image]');
      this.totalPriceEls = Array.from(this.querySelectorAll('[data-total-price]'));
      this.dosePriceEls = Array.from(this.querySelectorAll('[data-dose-price]'));
      this.doseReferenceEls = Array.from(this.querySelectorAll('[data-dose-reference]'));
      this.variantInput = this.querySelector('[data-variant-input]');
      this.submitBtn = this.querySelector('[data-submit]');
      this.form = this.querySelector('[data-plan-form]');
      this.backBtn = this.querySelector('[data-back]');

      if (this.select) {
        this.select.addEventListener('change', () => this.selectProduct(this.select.value, true));
      }

      if (this.backBtn) {
        this.backBtn.addEventListener('click', () => this.classList.remove('is-active'));
      }

      this.routineCards.forEach((card) => {
        card.addEventListener('click', () => this.selectRoutine(card));
      });

      if (this.form) {
        this.form.addEventListener('submit', (event) => {
          if (this.purchaseLink) {
            event.preventDefault();
            window.location.href = this.purchaseLink;
          }
        });
      }

      if (this.productOrder.length) this.selectProduct(this.productOrder[0]);
    }

    selectRoutine(card) {
      this.routineCards.forEach((c) => c.classList.toggle('is-selected', c === card));
      this.classList.add('is-active');

      const numDoses = parseInt(card.dataset.numDoses, 10);
      if (!isNaN(numDoses)) this.selectVariantByDoses(numDoses);
    }

    selectProduct(productId, keepDoses) {
      const product = this.products[productId];
      if (!product) return;

      let targetDoses = null;
      if (keepDoses && this.currentProductId && this.currentVariantId) {
        const prevProduct = this.products[this.currentProductId];
        const prevVariant = prevProduct && prevProduct.variants[this.currentVariantId];
        if (prevVariant) targetDoses = prevVariant.numDoses;
      }

      this.currentProductId = productId;
      if (this.select) this.select.value = productId;

      if (this.panelImage && product.image) {
        this.panelImage.src = product.image;
        this.panelImage.alt = product.imageAlt;
      }

      Object.keys(this.products).forEach((id) => {
        const p = this.products[id];
        if (p.pillsEl) p.pillsEl.hidden = id !== productId;
      });

      if (targetDoses != null) {
        this.selectVariantByDoses(targetDoses);
        return;
      }

      const firstVariantId = Object.keys(product.variants)[0];
      if (!firstVariantId) return;

      this.currentVariantId = firstVariantId;
      if (product.pillsEl) {
        Array.from(product.pillsEl.querySelectorAll('[data-variant-id]')).forEach((btn, index) => {
          btn.classList.toggle('is-active', index === 0);
        });
      }
      this.updatePrices();
    }

    selectVariantByDoses(numDoses) {
      const product = this.products[this.currentProductId];
      if (!product) return;

      const variantIds = Object.keys(product.variants);
      const matchId = variantIds.find((id) => product.variants[id].numDoses === numDoses) || variantIds[0];
      if (!matchId) return;

      this.currentVariantId = matchId;
      if (product.pillsEl) {
        Array.from(product.pillsEl.querySelectorAll('[data-variant-id]')).forEach((btn) => {
          btn.classList.toggle('is-active', btn.dataset.variantId === matchId);
        });
      }
      this.updatePrices();
    }

    updatePrices() {
      const product = this.products[this.currentProductId];
      const variant = product && product.variants[this.currentVariantId];
      if (!variant) return;

      const numDoses = variant.numDoses || 1;
      const oneTimeDosePrice = (variant.oneTimePrice || 0) / numDoses;
      const hasSubscription = !!variant.hasSubscription;

      const totalPrice = hasSubscription ? (variant.subscriptionPrice || 0) : (variant.oneTimePrice || 0);
      const dosePrice = totalPrice / numDoses;

      this.totalPriceEls.forEach((el) => { el.textContent = this.formatMoney(totalPrice); });
      this.dosePriceEls.forEach((el) => { el.textContent = this.formatMoney(dosePrice); });
      this.doseReferenceEls.forEach((el) => {
        el.textContent = hasSubscription ? this.formatMoney(oneTimeDosePrice) : '';
      });

      if (this.variantInput) {
        this.variantInput.value = hasSubscription ? (variant.subscriptionVariantId || variant.id) : variant.id;
      }
      this.purchaseLink = hasSubscription ? (variant.subscriptionPurchaseLink || '') : '';

      if (this.submitBtn) {
        this.submitBtn.disabled = false;
        this.submitBtn.classList.add('is-active');
      }
    }

    formatMoney(cents) {
      return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
  }

  customElements.define('subscription-plan-picker', SubscriptionPlanPicker);

  } catch(e) { console.error(e); }
})();
})();
